
export class MenuConfig {
	private qac = localStorage.getItem('qac');
	public defaults: any = {
		adminHeader: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					alignment: 'left',
					page: '/dashboard',
					admPermission: 'viewSuperAdminDashboard'
				},

				{
					title: 'Entity List',
					root: true,
					alignment: 'left',
					page: '/superAdmin/entityList',
					admPermission: 'viewEntityList'
				},
				{
					title: 'White Labelling',
					root: true,
					alignment: 'left',
					page: '/superAdmin/whiteLabelling',
					admPermission: 'viewWhiteLabellingList'
				},
				{
					title: 'FAQ',
					root: true,
					alignment: 'left',
					page: '/superAdmin/faq',
					admPermission: 'viewFAQList'
				},
				{
					title: 'Cron Logs',
					root: true,
					alignment: 'left',
					page: '/superAdmin/cronLogs',
					admPermission: 'viewCronLogs'
				},
				{
					title: 'Pdf Template',
					root: true,
					alignment: 'left',
					page: '/superAdmin/pdfTemplate',
					admPermission: 'viewDefaultPDFTemplateList'
				},
				{
					title: 'Excel Template',
					root: true,
					alignment: 'left',
					page: '/superAdmin/defaultExcelTemplates',
					admPermission:  'viewDefaultPDFTemplateList'
				},
				{
					title: 'Usage Analytics',
					root: true,
					alignment: 'left',
					page: '/superAdmin/usageAnalytics',
					admPermission: 'viewDefaultPDFTemplateList'
				},
				{
					title: 'Teacher MIS',
					root: true,
					alignment: 'left',
					page: '/superAdmin/teacherMis',
					admPermission: 'viewEntityList'
				},
				{
					title: 'Billing',
					root: true,
					alignment: 'left',
					page: '/superAdmin/billing',
					admPermission: 'viewEntityList'
				},
				{
					title: 'All Permissions',
					root: true,
					alignment: 'left',
					page: '/superAdmin/allPermissions',
					admPermission: 'viewAllPermissionsList'
				},
				{
					title: 'Default Communication Template',
					root: true,
					alignment: 'left',
					page: '/superAdmin/defaultCommunicationTemplate',
					admPermission: 'viewDefaultPDFTemplateList'
				},


			]
		},
		adminAside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					icon: 'flaticon3-house',
					page: '/dashboard',
					bullet: 'dot',
					admPermission: 'viewSuperAdminDashboard'
				},
				{
					title: 'Entity List',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list-2',
					page: '/superAdmin/entityList',
					admPermission: 'viewEntityList'
				},
				{
					title: 'Teacher MIS',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-notification',
					page: '/superAdmin/teacherMis',
					admPermission: 'viewEntityList'
				},
				{
					title: 'White Labelling',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list-2',
					page: '/superAdmin/whiteLabelling',
					admPermission: 'viewWhiteLabellingList'
				},
				{
					title: 'FAQ',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list-2',
					page: '/superAdmin/faq',
					admPermission: 'viewFAQList'
				},
				{
					title: 'Cron Logs',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list-2',
					page: '/superAdmin/cronLogs',
					admPermission: 'viewCronLogs'
				},
				{
					title: 'Pdf Template',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list-2',
					page: '/superAdmin/pdfTemplate',
					admPermission: 'viewDefaultPDFTemplateList'
				},
				{
					title: 'Excel Template',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list-2',
					page: '/superAdmin/defaultExcelTemplates',
					admPermission: 'viewDefaultPDFTemplateList'
				},
				{
					title: 'Usage Analytics',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list-2',
					page: '/superAdmin/usageAnalytics',
					admPermission: 'viewDefaultPDFTemplateList'
				},
				{
					title: 'Question Bank',
					bullet: 'dot',
					icon: 'flaticon-coins',
					//page:'/fee/collectOtherIncome',
					//entPermission: 'collectOtherIncome',
					admPermission: 'viewQuestionBankCourseNameMapperList',
					submenu: [
						{
							title: 'Course Mapper',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							page: '/superAdmin/courseMapper',
							admPermission: 'viewQuestionBankCourseNameMapperList',
							//entPermission:'collectOtherIncome',
						},
						{
							title: 'Subject Mapper',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							page: '/superAdmin/subjectMapper',
							admPermission: 'viewQuestionBankSubjectNameMapperList'
							//entPermission:'viewOtherIncomeTransactionList',
						},
						{
							title: 'Question Bank',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							page: '/superAdmin/questionBank',
							admPermission: 'viewQuestionBankList'
							//entPermission:'viewOtherIncomeTransactionList',
						},
					]

				},
				{
					title: 'Billing',
					root: true,
					alignment: 'left',
					page: '/superAdmin/billing',
					admPermission: 'viewEntityList'
				},
				{
					title: 'All Permissions',
					root: true,
					alignment: 'left',
					page: '/superAdmin/allPermissions',
					admPermission: 'viewAllPermissionsList'
				},
				{
					title: 'Default Communication Template',
					root: true,
					alignment: 'left',
					page: '/superAdmin/defaultCommunicationTemplate',
					admPermission: 'viewDefaultPDFTemplateList'
				},
				{
					title: 'Default Attachment Template',
					root: true,
					alignment: 'left',
					page: '/superAdmin/defaultAttachmentTemplate',
					admPermission: 'viewDefaultPDFTemplateList'
				},
				{
					title: 'Delete Entity Request',
					root: true,
					alignment: 'left',
					page: '/superAdmin/entityDelete',
					admPermission: 'viewDefaultPDFTemplateList'
				},
			]
		},
		entityHeader: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboard',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/entity/dashboard',
				// 	entPermission: 'viewEntityDashboard'
				// },

				// {
				// 	title: 'Student',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/student/studentList',
				// 	entPermission:'viewStudentList',
				// 	submenu: [
				// 		{
				// 			title: 'Student List',
				// 			bullet: 'dot',
				// 			icon: 'flaticon3-graduated',
				// 			page: '/student/studentList',
				// 			entPermission:'viewStudentList',
				// 		},
				// 		{
				// 			title: 'Student Session Managment',
				// 			bullet: 'dot',
				// 			icon: 'flaticon3-graduated',
				// 			page: '/student/studentSessionManage',
				// 			entPermission:'addStudentsToSession',
				// 		},
				// 		{
				// 			title: 'Strength Report',
				// 			bullet: 'dot',
				// 			icon: 'flaticon3-graduated',
				// 			page: '/student/strengthReport',
				// 			entPermission:'viewStudentStrengthReport',
				// 		},
				// 	]
				// },


				{
					title: 'Fee',
					root: true,
					alignment: 'left',
					// page: '/feeReports',
					entPermission: 'feeModule',
					// toggle: 'click',
					submenu: [
						{
							title: 'Collect Fee',
							// bullet: 'dot',
							icon: 'flaticon-coins',
							page: '/fee/collectFee',
							entPermission: 'collectFee',
						},

						{
							title: 'Collect Fee Online',
							// bullet: 'dot',
							icon: 'flaticon-coins',
							page: '/fee/collectFee',
							entPermission: 'collectFeeOnline',
						},
						{
							title: 'Collect Fee All Session',
							// bullet: 'dot',
							icon: 'flaticon-coins',
							page: '/fee/collectFeeAllSession',
							entPermission: 'collectFeeAllSession',
						},
						{
							title: 'Collect Miscellaneous Fee',
							// bullet: 'dot',
							icon: 'flaticon-coins',
							page: '/fee/collectFee/miscellenous',
							entPermission: 'collectFee',
						},
						{
							title: 'Other Income',
							bullet: 'dot',
							icon: 'flaticon-coins',
							page: '/fee/collectOtherIncome',
							entPermission: 'collectOtherIncome',
							submenu: [
								{
									title: 'Collect Other Income',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/collectOtherIncomeV2',
									entPermission: 'collectOtherIncome',
								},
								{
									title: 'Other Income Transaction List',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/otherIncomeTransactionList',
									entPermission: 'viewOtherIncomeTransactionList',
								}
							]
						},
						{
							title: 'Refund',
							bullet: 'dot',
							icon: 'flaticon-coins',
							page: '/fee/refund',
							entPermission: 'viewRefundTransactionList',
							submenu: [
								{
									title: 'Refund',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/refund',
									entPermission: 'getRefundDetails',
								},
								{
									title: 'Refund Transaction List',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/refundTransactionList',
									entPermission: 'viewRefundTransactionList',
								},
								{
									title: 'Refund Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/refundReport',
									entPermission: 'viewRefundTransactionList',
								},
								{
									title: 'Bulk Refund',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/bulkFeeRefund',
									entPermission: 'getBulkFeeRefundDetails',
								}
							]
						},
						{
							title: 'Fee Reports',
							bullet: 'dot',
							icon: 'flaticon-notepad',
							// page: '/feeReports',
							entPermission: 'viewFeeReports',
							// translate: 'MENU.DASHBOARD',
							submenu: [

								{
									title: 'Combined Daily Collection Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/combinedDailyCollectionReport',
									entPermission: 'viewCombinedDailyCollectionReport',
								},
								{
									title: 'Daily Fee Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dailyFeeReport',
									entPermission: 'viewDailyFeeReport',
								},
								{
									title: 'Fee Head Collection Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dailyFeeHeadCollectionReport',
									entPermission: 'viewDailyFeeHeadCollectionReport',
								},
								{
									title: 'Daily Payment Mode Collection Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dailyPaymentModeCollectionReport',
									entPermission: 'viewDailyPaymentModeCollectionReport',
								},
								{
									title: 'Due Fee Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dueFeeReport',
									entPermission: 'viewDueFeeReport',
								},
								{
									title: 'Due Fee Report Course Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dueFeeReportCourseWise',
									entPermission: 'viewDueFeeReportCourseWise',
								},

								{
									title: 'Multi Session Due Fee Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/multiSessionDueFeeReport',
									entPermission: 'viewMultiSessionDueFeeReport',
								},
								{
									title: 'Concession Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/concessionReport',
									entPermission: 'viewConcessionReport',
								},
								{
									title: 'Concession Utilization Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/concessionUtilizationReport',
									entPermission: 'viewConcessionUtilizationReport',
								},
								{
									title: 'Student Payment Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/studentPaymentSummary',
									entPermission: 'viewStudentPaymentSummary',

								},
								{
									title: 'Transport Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/transportReport',
									entPermission: 'viewTransportReport',
								},
								{
									title: 'Fee Register Student Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/feeRegisterStudentWise',
									entPermission: 'viewStudentWiseFeeRegister',
								},
								{
									title: 'Due Fee Report Sibling Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dueFeeSiblingReport',
									entPermission: 'viewDueFeeReport',
								},
							]
						},
						{
							title: 'Fee Summary',
							bullet: 'dot',
							icon: 'flaticon-notepad',
							// page: '/feeReports',
							entPermission: 'viewCourseWiseCollectionReport',
							// translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Fee Summary - Course Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/courseWiseReport',
									entPermission: 'viewCourseWiseCollectionReport',
								},
								{
									title: 'Fee Summary - Category Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/categoryWiseReport',
									entPermission: 'viewCategoryWiseCollectionReport',
								},
								{
									title: 'Fee Summary - Head Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/feeHeadWiseReport',
									entPermission: 'viewFeeHeadWiseCollectionReport',
								},
								{
									title: 'Fee Summary - Group Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/feeGroupWiseReport',
									entPermission: 'viewFeeHeadGroupWiseCollectionReport',
								},
								{
									title: 'Fee Summary - Combined Head Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/combinedHeadWiseFeeSummary',
									entPermission: 'viewCombinedHeadWiseCollectionReport',
								},
{
							title: 'Pocket Money',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'dashboardPocketMoney',
							// translate: 'MENU.DASHBOARD',
							submenu: [


								{
									title: 'Dashbord',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/pocketMoneyDashboard',
									entPermission: 'dashboardPocketMoney',
								},
								{
									title: 'Wallet & Transaction',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/pocketMoneyWalletAndTransaction',
									entPermission: 'collectionReportPocketMoney',

								},
							]
						},
							]
						},
						{
							title: 'Transaction List',
							bullet: 'dot',
							icon: 'flaticon2-list-2',
							page: '/fee/transactionList',
							entPermission: 'viewTransactionList'
						},
						{
							title: 'Fee Adjustment',
							bullet: 'dot',
							icon: 'flaticon2-list-2',
							page: '/fee/feeAdjusment',
							entPermission: 'createAdjustmentTransaction'
						},
						{
							title: ' Online Transaction List',
							bullet: 'dot',
							icon: 'flaticon2-list-2',
							page: '/fee/onlineTransactionList',
							entPermission: 'viewOnlineTransactionList'
						},
						{
							title: 'Fee Head Register Report',
							bullet: 'dot',
							icon: 'flaticon2-list-2',
							page: '/fee/feeHeadRegisterReport',
							entPermission: 'viewFeeHeadRegister'
						}
					]
					// translate: 'MENU.DASHBOARD',
				},

				// {
				// 	title: 'Users',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/users',
				// 	entPermission:'viewUserList',
				// },
				// {
				// 	title: 'Attendance',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/studentAttendance',
				// 	entPermission:'attendanceModule',
				// 	submenu: [
				// 		{
				// 			title: 'Student Attendance',
				// 			bullet: 'dot',
				// 			icon: 'flaticon3-calendar',
				// 			page:'/attendance/studentAttendance',
				// 			entPermission: 'viewStudentAttendanceList',
				// 		},
				// 	]
				// },
				// {
				// 	title: 'HRM',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/hrm',
				// 	entPermission:'hrmModule',
				// 	submenu: [
				// 		{
				// 			title: 'Employee',
				// 			bullet: 'dot',
				// 			icon: 'flaticon3-team',
				// 			page:'/hrm/employee',
				// 			entPermission: 'viewEmployeeList',
				// 		},
				// 	]
				// },

				{
					title: 'Advanced',
					root: true,
					alignment: 'left',
					page: 'advancedSetup/advancedMaster',
					entPermission: 'advancedModule',
					submenu: [
						{
							title: 'Resource Person',
							bullet: 'dot',
							icon: 'flaticon-information',
							page: '/advancedSetup/resourcePerson',
							entPermission: 'viewResourcePersonList',
						},
						{
							title: 'Seminar',
							bullet: 'dot',
							icon: 'flaticon-information',
							page: '/advancedSetup/seminar',
							entPermission: 'viewSeminarList',
						},
						{
							title: 'Events',
							bullet: 'dot',
							icon: 'flaticon-information',
							page: '/advancedSetup/event',
							entPermission: 'viewEventList',
						},
						{
							title: 'Alumni',
							bullet: 'dot',
							icon: 'flaticon-information',
							page: '/advancedSetup/alumni',
							entPermission: 'viewAlumniList',
						},
						{
							title: 'Research Publication',
							bullet: 'dot',
							icon: 'flaticon-information',
							page: '/advancedSetup/researchPublication',
							entPermission: 'viewResearchPublicationList',
						},
						{
							title: 'Book/Chapter/Proceeding',
							bullet: 'dot',
							icon: 'flaticon-information',
							page: '/advancedSetup/bookChapterPublication',
							entPermission: 'viewBookChapterPublicationList',
						},
							{
							title: 'Incentive Report',
							bullet: 'dot',
							icon: 'flaticon-information',
							page: '/advancedSetup/incentiveReport',
							entPermission: 'isResearchPublicationAdmin',
						},

					]
				},
				{
					title: 'Analytics',
					alignment: 'left',
					root: true,
					page: '/analytics',
					entPermission: 'analyticsModule',
					submenu: [
						{
							title: 'Dashboard',
							bullet: 'dot',
							icon: 'flaticon2-graphic',
							page: '/analytics/dashboard',
							entPermission: 'viewAnalyticsDashboard',
						},
						{
							title: 'Registration',
							bullet: 'dot',
							icon: 'flaticon-notes',
							page: '/analytics/registration',
							entPermission: 'viewRegistrationAnalyticsList',
						},
						{
							title: 'Admission',
							bullet: 'dot',
							icon: 'flaticon-interface-10',
							page: '/analytics/admission',
							entPermission: 'viewAdmissionAnalyticsList',
						},
						{
							title: 'Admission Reports',
							bullet: 'dot',
							icon: 'flaticon-interface-10',
							// page:'/analytics/partnerInstitute',
							entPermission: 'viewAnalyticsReports',
							submenu: [
								{
									title: 'Registration Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/registrationReport',
									entPermission: 'viewRegistrationReports',
								},
								{
									title: 'Admission Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/admissionReport',
									entPermission: 'viewAdmissionSummary',
								},
								{
									title: 'Partner Registration Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerRegistrationData',
									entPermission: 'viewPartnerRegistrationSummary',
								},
								{
									title: 'Partner Admission Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerAdmissionData',
									entPermission: 'viewPartnerAdmissionSummary',
								},
							]
						},
						{
							title: 'Placement Reports',
							bullet: 'dot',
							icon: 'flaticon-interface-10',
							// page:'/analytics/partnerInstitute',
							entPermission: 'viewAnalyticsReports',
							submenu: [

								{
									title: 'Partner Placement Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerPlacementSummary',
									entPermission: 'getCompanyListPlacementDriveData',
								},
								{
									title: 'Partner Placement Summary Session Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerPlacementSummarySessionWise',
									entPermission: 'getSessionWiseCompanyListPlacementDriveData',
								},

								{
									title: 'Placement Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/placementSummary',
									entPermission: 'getPlacementDriveSummary',
								},
								{
									title: 'Placement Summary Session Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerSummarySessionWise',
									entPermission: 'getSessionWisePlacementDriveSummary',
								},
							]
						},
						{
							title: 'Partner Institutes',
							bullet: 'dot',
							icon: 'flaticon-interface-10',
							// page:'/analytics/partnerInstitute',
							entPermission: 'viewPartnerInstituteList',
							submenu: [
								{
									title: 'Manage',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerInstitute',
									entPermission: 'viewPartnerInstituteList',
								},
								{
									title: 'Registration Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerRegistrationData',
									entPermission: 'viewPartnerRegistrationSummary',
								},
								{
									title: 'Admission Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerAdmissionData',
									entPermission: 'viewPartnerAdmissionSummary',
								},
							]
						},
						{
							title: 'Partner Companies',
							bullet: 'dot',
							icon: 'flaticon-interface-10',
							// page:'/analytics/partnerCompany',
							entPermission: 'viewPartnerCompanyList',
							page: '/analytics/partnerCompany'
						},
						{
							title: 'Visits',
							bullet: 'dot',
							icon: 'flaticon-interface-10',
							page: '/analytics/visit',
							entPermission: 'viewVisitList',
						},
						{
							title: 'Placement Drive',
							bullet: 'dot',
							icon: 'flaticon-interface-10',
							page: '/analytics/placementDrive',
							entPermission: 'viewPlacementDriveList',
						},
						{
							title: 'Internship Management',
							bullet: 'dot',
							icon: 'flaticon-interface-10',
							page: '/analytics/internshipManagement',
							entPermission: 'viewInternshipList',
						},

					]
				},

				// {
				// 	title: 'Library',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/library',
				// 	entPermission:'libraryModule',
				// 	submenu: [
				// 		{
				// 			title: 'Books',
				// 			bullet: 'dot',
				// 			icon: 'flaticon2-open-text-book',
				// 			page:'/library/libraryBook',
				// 			entPermission: 'viewLibraryBookList',
				// 		},
				// 		{
				// 			title: 'Issue Book',
				// 			bullet: 'dot',
				// 			icon: 'flaticon-folder-3',
				// 			page:'/library/issueBook',
				// 			entPermission: 'issueLibraryBook',
				// 		},
				// 		{
				// 			title: 'Issue Records',
				// 			bullet: 'dot',
				// 			icon: 'flaticon-folder-2',
				// 			page:'/library/issueRecords',
				// 			entPermission: 'getAllLibraryIssueRecords',
				// 		},
				// 		{
				// 			title: 'Quick Report',
				// 			bullet: 'dot',
				// 			icon: 'flaticon-folder-2',
				// 			page:'/library/quickReport',
				// 			entPermission: 'countLibraryBooks',
				// 		},
				// 		{
				// 			title: 'Stock Verify',
				// 			bullet: 'dot',
				// 			icon: 'flaticon-folder-1',
				// 			page:'/library/stockVerify',
				// 			entPermission: 'libraryStockVerify',
				// 		},
				// 	]
				// },

				{
					title: 'Admission',
					root: true,
					alignment: 'left',
					page: '/admission',
					entPermission: 'admissionModule',
					submenu: [
						{
							title: 'Application Data',
							bullet: 'dot',
							icon: 'flaticon-list-1',
							page: '/admission/studentData',
							entPermission: 'viewAdmissionStudentDataList',
						},
						{
							title: 'Admission Leads',
							bullet: 'dot',
							icon: 'flaticon-list-1',
							page: '/admission/admissionLeads',
							entPermission: 'viewAdmissionStudentDataList',
						},
						{
							title: 'Transactions',
							bullet: 'dot',
							icon: 'flaticon2-calendar-5',
							page: '/admission/transaction',
							entPermission: 'viewAdmissionTransactionList',
						},
						{
							title: 'Admission Reports',
							bullet: 'dot',
							icon: 'flaticon-notepad',
							// page: '/feeReports',
							entPermission: 'viewAdmissionReports',
							// translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Daily Collection Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/dailyCollectionReport',
									entPermission: 'viewDailyAdmissionCollectionReport',
								},
								{
									title: 'Admission Summary Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/admissionSummaryReports',
									entPermission: 'viewAdmissionSummaryReport',
								}
								,
								{
									title: 'Subject Combination Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/vacentSeats',
									entPermission: 'viewSubjectCombinationReport',
								},
								{
									title: 'NEP Subject Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/nepSubjectReport',
									entPermission: 'viewNEPSubjectReport',
								},
								{
									title: 'Counselor Productivity Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/counselorProductivityReport',
									entPermission: 'viewCounselorProductivityReport',
								},
								{
									title: 'Source Wise Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/sourceWiseReport',
									entPermission: 'viewAdmissionSourceWiseReport',
								},
								{
									title: 'Counselor Tag Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/counselorTagReport',
									entPermission: 'viewAdmissionCounselorTagReport',
								},
								{
									title: 'Course Wise Tag Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/courseWiseTagReport',
									entPermission: 'viewAdmissionCourseTagReport',
								},

								{
									title: 'Counselor Stage Wise Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/counselorStageWiseReport',
									entPermission: 'viewCounselorStageReport',
								},
								{
									title: 'Follow Up Remark Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/followUpRemarkReport',
									entPermission: 'viewAdmissionStudentDataList',
						        },
								

							]
						},
						{
							title: 'Follow Ups',
							bullet: 'dot',
							icon: 'flaticon2-calendar-5',
							page: '/admission/followUps',
							entPermission: 'viewAdmissionStudentData',
						},
						{
							title: 'Admission Lead Logs',
							bullet: 'dot',
							icon: 'flaticon2-calendar-5',
							page: '/admission/admissionLeadLogs',
							entPermission: 'viewAdmissionLeadLogsList',
						},

					]
				},
				// {
				// 	title: 'Share Point',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/sharePoint',
				// 	entPermission:'sharePointModule',
				// },
			]
		},
		entityAside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					icon: 'flaticon3-house',
					page: '/entity/dashboard',
					bullet: 'dot',
					entPermission: 'viewEntityDashboard'
				},
				{
					title: 'Employee Portal',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-team',
					//page:'/hrm',
					entPermission: 'profileDashboard',
					submenu: [
						{
							title: 'Employee Portal',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/profilePortal/profile',
							entPermission: 'profileDashboard',
							submenu: [
								{
									title: 'Profile',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/profilePortal/profile',
									entPermission: 'profileDashboard',
								},

								{
									title: 'My Leaves',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/profilePortal/applyLeaves',
									entPermission: 'viewEmployeeLeaveList',
								},
								{
									title: 'Lecture Adjustment Requests',
									bullet: 'dot',
									page: '/profilePortal/lectureAdjustmentRequests',
									entPermission: 'viewEmployeeLeave',
								},
								{
									title: 'Salary Slip',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeSalarySummary',
									entPermission: 'viewEmployeeSalaryList',
								},
								{
									title: 'Calendar',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/profilePortal/calendar',
									entPermission: 'calendarDashboard',
								},
								{
									title: 'My Task',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/profilePortal/myTask',
									entPermission: 'viewUserTaskList',
								},
								{
									title: 'Compensatory Leave Request',
									bullet: 'dot',
									page: '/profilePortal/compensatoryOff',
									entPermission: 'viewEmployeeCompensatoryLeaveList',
								},
								{
									title: 'Attendance Regularization',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeAttendanceRegularization',
									entPermission: 'viewEmployeeAttendanceRegularizationList',
								},
								{
									title: 'Issued Books',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/issueRecords/employeeDetails',
									entPermission: 'getAllLibraryIssueRecords',
								},
								{
									title: 'User Preference',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/profilePortal/userPreference',
									entPermission: 'profileDashboard',
								},
								{
									title: 'Web Tabs',
									bullet: 'dot',
									page: '/profilePortal/webTabs',
									entPermission: 'viewWebTabEmployee',
								},
								{
									title: 'Employee Announcement',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/communication/employeeAnnouncement',
									entPermission: 'viewEmployeeAnnouncementList',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'WebOPAC',
									bullet: 'dot',
									// icon: 'flaticon3-analytics',
									page: `/web-opac`,
									entPermission: 'viewWebOPAC',
								},
								{
									title: 'Individual Faculty Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/individualFacultyReport',
									entPermission: 'individualFacultyReport',
								},
								{
									title: 'Feedback Summary Report (New)',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/classSectionWiseFeedbackSummaryReport',
									entPermission: 'questionWiseFeedbackSummaryReport',
								},								
							
								{
									title: 'Attendance Calendar',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeAttendanceCalendar',
									entPermission: 'getEmployeeAttendanceCalendar',
								},
							]
						}

					]
				},
				{
					title: 'Admission',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-report',
					page: '/admission',
					entPermission: 'admissionModule',
					submenu: [
						{
							title: 'Student Registration',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/admission/studentData',
							entPermission: 'admissionModule',
							submenu: [
								{
									title: 'Application Data',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/admission/studentData',
									entPermission: 'viewAdmissionStudentDataList',
								},
								{
									title: 'Admission Leads',
									bullet: 'dot',
									icon: 'flaticon-list-1',
									page: '/admission/admissionLeads',
									entPermission: 'viewAdmissionStudentDataList',
								},
								{
									title: 'Follow Ups',
									bullet: 'dot',
									icon: 'flaticon2-calendar-5',
									page: '/admission/followUps',
									entPermission: 'viewAdmissionStudentData',
								},
								{
									title: 'Follow Up Remark Report',
                  bullet: 'dot',
                  icon: 'flaticon2-list-2',
                  page: '/admission/followUpRemarkReport',
                  entPermission: 'viewAdmissionStudentDataList',
                },
                {
                  title: 'Admission Transactions',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/admission/transaction',
									entPermission: 'viewAdmissionTransactionList',
								},
							]
						},
						{
							title: 'Admission Reports',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewAdmissionReports',
							// translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Daily Collection Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/dailyCollectionReport',
									entPermission: 'viewDailyAdmissionCollectionReport',
								},
								{
									title: 'Admission Summary Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/admissionSummaryReports',
									entPermission: 'viewAdmissionSummaryReport',
								},
								{
									title: 'Subject Combination Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/vacentSeats',
									entPermission: 'viewSubjectCombinationReport',
								},
								{
									title: 'NEP Subject Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/nepSubjectReport',
									entPermission: 'viewNEPSubjectReport',
								},
								{
									title: 'Counselor Productivity Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/counselorProductivityReport',
									entPermission: 'viewCounselorProductivityReport',
								},
								{
									title: 'Source Wise Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/sourceWiseReport',
									entPermission: 'viewAdmissionSourceWiseReport',
								},
								{
									title: 'Counselor Tag Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/counselorTagReport',
									entPermission: 'viewAdmissionCounselorTagReport',
								},
								{
									title: 'Course Wise Tag Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/courseWiseTagReport',
									entPermission: 'viewAdmissionCourseTagReport',
								},
								{
									title: 'Admission Lead Logs',
									bullet: 'dot',
									icon: 'flaticon2-calendar-5',
									page: '/admission/admissionLeadLogs',
									entPermission: 'viewAdmissionLeadLogsList',
								},
								{
									title: 'Counselor Stage Wise Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/counselorStageWiseReport',
									entPermission: 'viewCounselorStageReport',
								},
                {
									title: 'Follow Up Remark Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/admission/followUpRemarkReport',
									entPermission: 'viewAdmissionStudentDataList',
						        },
								
							]
						},
					]
				},
				// {
				// 	title: 'Admission V2',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'flaticon3-report',
				// 	page: '/admissionv2',
				// 	entPermission: 'admissionModule',
				// },
				{
					title: 'Student',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-graduated',
					page: '/student/studentList',
					entPermission: 'studentModule',
					submenu: [
						{
							title: 'Student',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/student/studentList',
							entPermission: 'studentModule',
							submenu: [
								{
									title: 'Student List',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/studentList',
									entPermission: 'viewStudentList',
								},
								{
									title: 'Student List Course Wise',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/studentListCourseWise',
									entPermission: 'studentListCourseWise',
								},
								{
									title: 'Student Certificates',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/studentCertificates',
									entPermission: 'downloadStudentCertificates',
								},
								{
									title: 'Student Feedback',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/studentFeedback',
									entPermission: 'viewStudentTimelineList',
								}
								// {
								// 	title: 'Student Concession',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page: '/student/concession',
								// 	entPermission: 'viewStudentConcessionList',
								// }
							]
						},


						{
							title: 'Student Utilities',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							page: '/student/studentUtilities',
							entPermission: 'viewStudentUtilities',
							submenu: [
								{
									title: 'Update RegNo',
									bullet: 'dot',
									page: '/student/studentUtilities',
									entPermission: 'viewStudentUtilities'
								},
								{
									title: 'Update Height & Weight',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/academicsSetup/updateStudentDetails',
									entPermission: 'updateMultipleStudentDetails',
								},
								{
									title: 'Assign Roll No.',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/academicsSetup/assignRollNo',
									entPermission: 'assignStudentRollNo',
								},
								{
									title: 'Allocate Subjects',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/academicsSetup/allocateSubjects',
									entPermission: 'allocateSubjectsToStudents',
								},
								{
									title: 'Student Session Management',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/studentSessionManage',
									entPermission: 'addStudentsToSession',
								},
							]
						},
						{
							title: 'Student Academic Reports',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							page: '/student/allocatedSubjectReport',
							entPermission: 'viewAllocatedSubjectsReport',
							submenu: [
								{
									title: 'Allocated Subject Report',
									bullet: 'dot',
									page: '/student/allocatedSubjectReport',
									entPermission: 'viewAllocatedSubjectsReport'
								},
								{
									title: 'Subject Wise Count Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/subjectWiseCountReport',
									entPermission: 'viewSubjectCountReport',
								},
								{
									title: 'Subject Combination Wise Count Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/subjectCombinationWiseCountReport',
									entPermission: 'viewSubjectCombinationCountReport',
								},
							]
						},
						{
							title: 'Student Reports',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page:'/student/strengthReport',
							entPermission: 'viewStudentList',
							submenu: [
								{
									title: 'Export Data',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/exportReport',
									entPermission: 'viewStudentList',
								},
								{
									title: 'University Data',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/universityReport',
									entPermission: 'viewUniversityData',
								},
								{
									title: 'Strength Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/strengthReport',
									entPermission: 'viewStudentStrengthReport',
								},

								{
									title: 'Gender Wise Category Report',
									bullet: 'dot',
									page: '/student/genderWiseCategoryStrengthReport',
									entPermission: 'viewStudentGenderCategoryStrengthReport'
								},
								{
									title: 'Sibling Report',
									bullet: 'dot',
									page: '/student/siblingReports',
									entPermission: 'viewSiblingReport'
								},
								{
									title: 'Feedback Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/studentFeedbackReport',
									entPermission: 'isStudentTimelineAdmin',
								},
								{
									title: 'Admission Withdrawal Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/admisssionWithdrawalRegister',
									entPermission: 'viewStudentAdmissionWithdrawalReport',
								},
								{
									title: 'Certificate Issuance Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/certificateIssuranceReport',
									entPermission: 'studentCertificateReport',
								},
								{
									title: 'Student Mapping Status to Od Pay',
									bullet: 'dot',
									page: '/student/odPaySyncReport',
									entPermission: 'odPaySyncReport',
								},

							],
						},


					]
				},
				// {
				// 	title: 'Student List V2',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'flaticon3-graduated',
				// 	page: '/studentListv2',
				// 	entPermission: 'studentModule',
				// },
				{
					title: 'Fee',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-money-1',
					// page: '/feeReports',
					entPermission: 'feeModule',
					submenu: [
						{
							title: 'Collect Fee',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/fee/collectFee',
							entPermission: 'feeModule',
							submenu: [
								{
									title: 'Collect Fee',
									bullet: 'dot',
									// iconx: 'flaticon-coins',
									page: '/fee/collectFee',
									entPermission: 'collectFee',
								},
								{
									title: 'Collect Fee Online',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/fee/collectFee',
									entPermission: 'collectFeeOnline',
								},
								{
									title: 'Collect Fee All Session',
									bullet: 'dot',
									//icon: 'flaticon-coins',
									page: '/fee/collectFeeAllSession',
									entPermission: 'collectFeeAllSession',
								},
								{
									title: 'Collect Miscellaneous Fee',
									// bullet: 'dot',
									icon: 'flaticon-coins',
									page: '/fee/collectFee/miscellenous',
									entPermission: 'collectFee',
								},
								{
									title: 'Fee Update',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page:'/fee/feeUpdate',
									entPermission: 'editStudentDemand'
								}
							]
						},

						{
							title: 'Other Income',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							page: '/fee/collectOtherIncome',
							entPermission: 'collectOtherIncome',
							submenu: [
								{
									title: 'Collect Other Income',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/collectOtherIncomeV2',
									entPermission: 'collectOtherIncome',
								},
								{
									title: 'Other Income Transaction List',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/otherIncomeTransactionList',
									entPermission: 'viewOtherIncomeTransactionList',
								},
							]
						},

						{
							title: 'Transaction',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/fee/transactionList',
							entPermission: 'feeModule',
							submenu: [
								{
									title: 'Transaction List',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/transactionList',
									entPermission: 'viewTransactionList',
								},
								{
									title: 'Fee Adjustment',
									bullet: 'dot',
									icon: 'flaticon2-list-2',
									page: '/fee/feeAdjusment',
									entPermission: 'createAdjustmentTransaction'
								},
								{
									title: ' Online Transaction List',
									bullet: 'dot',
									icon: 'flaticon2-list-2',
									page: '/fee/onlineTransactionList',
									entPermission: 'viewOnlineTransactionList'
								},
								{
									title: 'Fee Head Register Report',
									bullet: 'dot',
									icon: 'flaticon2-list-2',
									page: '/fee/feeHeadRegisterReport',
									entPermission: 'viewFeeHeadRegister'
								}
							]
						},
						{
							title: 'Concession',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/fee/transactionList',
							entPermission: 'feeModule',
							submenu: [

								{
									title: 'Concession Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/concessionReport',
									entPermission: 'viewConcessionReport',
								},
								{
									title: 'Concession Utilization Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/concessionUtilizationReport',
									entPermission: 'viewConcessionUtilizationReport',
								},

							]
						},
						{
							title: 'Refund',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							page: '/fee/refund',
							entPermission: 'viewRefundTransactionList',
							submenu: [
								{
									title: 'Refund',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/refund',
									entPermission: 'getRefundDetails',
								},
								{
									title: 'Refund Transaction List',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/refundTransactionList',
									entPermission: 'viewRefundTransactionList',
								},
								{
									title: 'Refund Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/refundReport',
									entPermission: 'viewRefundTransactionList',
								},
								{
									title: 'Bulk Refund',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/bulkFeeRefund',
									entPermission: 'getBulkFeeRefundDetails',
								}
							]
						},
						{
							title: 'Fee Reports',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewFeeReports',
							// translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Combined Daily Collection Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/combinedDailyCollectionReport',
									entPermission: 'viewCombinedDailyCollectionReport',
								},
								{
									title: 'Daily Fee Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dailyFeeReport',
									entPermission: 'viewDailyFeeReport',
								},
								{
									title: 'Fee Head Collection Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dailyFeeHeadCollectionReport',
									entPermission: 'viewDailyFeeHeadCollectionReport',
								},
								{
									title: 'Daily PaymentMode Collection Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dailyPaymentModeCollectionReport',
									entPermission: 'viewDailyPaymentModeCollectionReport',
								},
								{
									title: 'Due Fee Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dueFeeReport',
									entPermission: 'viewDueFeeReport',
								},
								{
									title: 'Due Fee Report Course Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dueFeeReportCourseWise',
									entPermission: 'viewDueFeeReportCourseWise',
								},
								{
									title: 'Multi Session Due Fee Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/multiSessionDueFeeReport',
									entPermission: 'viewMultiSessionDueFeeReport',
								},


								// {
								// 	title: 'Transport Report',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page: '/student/transportReport',
								// 	entPermission: 'viewTransportReport',
								// },
								{
									title: 'Transport Due Fee Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/fee/transportDueFeeReport',
									entPermission: 'viewTransportReport',
								},
								{
									title: 'Fee Register Student Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/feeRegisterStudentWise',
									entPermission: 'viewStudentWiseFeeRegister',
								},
								{
									title: 'Due Fee Report Sibling Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/dueFeeSiblingReport',
									entPermission: 'viewDueFeeReport',
								},
							]
						},


						{
							title: 'Fee Summary',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewCourseWiseCollectionReport',
							// translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Fee Summary - Course Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/courseWiseReport',
									entPermission: 'viewCourseWiseCollectionReport',
								},
								{
									title: 'Fee Summary - Category Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/categoryWiseReport',
									entPermission: 'viewCategoryWiseCollectionReport',
								},
								{
									title: 'Fee Summary - Head Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/feeHeadWiseReport',
									entPermission: 'viewFeeHeadWiseCollectionReport',
								},
								{
									title: 'Fee Summary - Group Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/feeGroupWiseReport',
									entPermission: 'viewFeeHeadGroupWiseCollectionReport',
								},
								{
									title: 'Fee Summary - Combined Head Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/combinedHeadWiseFeeSummary',
									entPermission: 'viewCombinedHeadWiseCollectionReport',
								},
								{
									title: 'Student Payment Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/studentPaymentSummary',
									entPermission: 'viewStudentPaymentSummary',

								},
							]
						},
						{
							title: 'Pocket Money',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'dashboardPocketMoney',
							// translate: 'MENU.DASHBOARD',
							submenu: [


								{
									title: 'Dashbord',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/pocketMoneyDashboard',
									entPermission: 'dashboardPocketMoney',
								},
								{
									title: 'Wallet & Transaction',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/fee/pocketMoneyWalletAndTransaction',
									entPermission: 'collectionReportPocketMoney',

								},
							]
						},
					]
				},
				{
					title: 'Accounting',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-money-1',
					// page:'/accounting',
					entPermission: 'accountingModule',
					submenu: [
						{
							title: 'Accounting',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/accounting/accounting',
							entPermission: 'accountingModule',
							submenu: [
								{
									title: 'Accounting',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/accounting/accounting',
									entPermission: 'accountingModule',
								},
								{
									title: 'Manage Cash',
									bullet: 'dot',
									page: '/accounting/manageCash',
									entPermission: 'getManageCashList'
								},
								{
									title: 'Voucher',
									bullet: 'dot',
									page: '/accounting/voucher',
									entPermission: 'viewAccountingVoucherList'
								},
								{
									title: 'Income & Expenditure A/c Report',
									bullet: 'dot',
									page: '/accounting/incomeExpenditureReport',
									entPermission: 'getIncomeAndExpenditureAccount'
								},
								{
									title: 'Book Print Report',
									bullet: 'dot',
									page: '/accounting/bookPrintReport',
									entPermission: 'accountingModule'
								}
							]
						},
					]
				},
				{
					title: 'Expense Management',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-group',
					page: '/expenseManagement/expenseManagementSystem',
					entPermission: 'viewExpenseManagementList',
					// submenu: [
					// 	{
					// 		title: 'Expense Management',
					// 		bullet: 'dot',
					// 		// icon: 'flaticon-coins',
					// 		page: '/expenseManagement',
					// 		entPermission: 'viewExpenseManagementList',
					// 	},
					// ]
				},

				{
					title: 'Attendance Old',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-calendar',
					page: '/studentAttendance',
					entPermission: 'attendanceModule',
					submenu: [
						{
							title: 'Mark Attendance Day Wise',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/attendance/studentAttendance',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Student Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/studentAttendance',
									entPermission: 'viewStudentAttendanceList',
								},
								{
									title: 'Student Attendance V2',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/studentAttendanceV2',
									entPermission: 'viewMultiCourseStudentAttendanceList',
								},
								{
									title: 'Student Attendance Teacher Wise',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/markAttendanceTeacherWise',
									entPermission: 'viewTeacherWiseStudentAttendanceList',
								},
								{
									title: 'Mark All Student Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/markAllStudentAttendance',
									entPermission: 'markAllStudentAttendance',
								},


							]
						},
						{
							title: 'Time Table',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/attendance/studentAttendance',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Daily Schedule For Employees',
									bullet: 'dot',
									page: '/attendance/dailyScheduleEmployees',
									entPermission: 'viewDailyTimeTableSchedule'
								},
								{
									title: 'Employee Schedule',
									bullet: 'dot',
									page: '/attendance/singleEmployeeSchedule',
									entPermission: 'viewEmployeeTimeTableSchedule'
								},
								{
									title: 'Course Wise Schedule',
									bullet: 'dot',
									page: '/attendance/timeTableCourseWise',
									entPermission: 'viewCourseTimeTableSchedule'
								},
								{
									title: 'Time Table Status',
									bullet: 'dot',
									page: '/attendance/timeTableStatus',
									entPermission: 'timeTableStatusReport'
								},
								{
									title: 'Faculty Availability Report',
									bullet: 'dot',
									page: '/attendanceNew/facultyAvailabilityReport',
									entPermission: 'viewFacultyAvailabilityReport'
								},
							]
						},
						{
							title: 'Attendance Reports',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/attendance/studentAttendance',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Daily Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/attendanceReport',
									entPermission: 'viewAttendanceReport',
								},
								{
									title: 'Attendance Summary',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/attendanceSummary',
									entPermission: 'viewAttendanceSummary',
								},
								{
									title: 'Course Wise Attendance Report - All Subject',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/courseWiseSummary',
									entPermission: 'viewAllSubjectsAttendanceSummary',
								},
								{
									title: 'Employee Wise Daily Attendance Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/employeeWiseDailyAttendanceReport',
									entPermission: 'viewEmployeeWiseAttendanceReport',
								},
								{
									title: 'Institute Summary',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/instituteSummary',
									entPermission: 'viewInstituteAttendanceSummary',
								},

								{
									title: 'Not Marked Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/notMarkedReport',
									entPermission: 'viewAttendanceNotMarkedReport',
								},
								{
									title: 'Lecture Wise Not Marked Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/lectureWiseNotMarkedReport',
									entPermission: 'viewLectureWiseAttendanceNotMarkedReport',
								},
								{
									title: 'Executive Daily Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendance/edrAttendanceReport',
									entPermission: 'viewEDRReport',
								},
								{
									title: 'Department Teacher Lecture Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/departmentTeacherLectureReport',
									entPermission: 'departmentTeacherLectureReport',
								},
								{
									title: 'Student Absentee Report',
									bullet: 'dot',
									page: '/attendance/studentList',
									entPermission: 'viewAbsenteeReport',
								},
							]
						},
						{
							title: 'Leave & Attendance Marks',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/attendance/studentAttendance',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Applied Leave',
									bullet: 'dot',
									page: '/attendance/appliedLeave',
									entPermission: 'viewAppliedLeaveList'
								},
								{
									title: 'Attendance Marks',
									bullet: 'dot',
									page: '/attendance/attendanceMarks',
									entPermission: 'calculateAttendanceMarks'
								},
							]
						},
						{
							title: 'Club Attendance',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page:'/student/strengthReport',
							entPermission: 'viewStudentClubList',
							submenu: [
								{
									title: 'Student Clubs',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/schoolSetup/studentClubs',
									entPermission: 'viewStudentClubList',
								},
								{
									title: 'Club Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/clubAttendance',
									entPermission: 'getListStudentClubAttendance',
								},
								{
									title: 'Club Attendance Marked Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/clubAttendanceMarked',
									entPermission: 'markedReportStudentClubAttendance',
								},
								{
									title: 'Club Attendance Summary Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/clubAttendanceSummaryWise',
									entPermission: 'summaryReportStudentClubAttendance',
								},

							],
						},

					]
				},
				{
					title: 'Attendance',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-calendar',
					// page: '/studentAttendance',
					entPermission: 'attendanceModule',
					submenu: [
						{
							title: 'Mark Attendance',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/attendance/studentAttendance',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Student Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/studentAttendance',
									entPermission: 'viewStudentAttendanceList',
								},
								{
									title: 'Student Attendance V2',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/studentAttendanceV2',
									entPermission: 'viewMultiCourseStudentAttendanceList',
								},
								{
									title: 'Student Attendance Teacher Wise',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/markAttendanceTeacherWise',
									entPermission: 'viewTeacherWiseStudentAttendanceList',
								},
								{
									title: 'Back Date Attendance Marking',
									bullet: 'dot',
									page: '/attendanceNew/backDateAttendanceMarking',
									entPermission: 'viewBackDateAttendanceMarkingList',
								},
							]
						},
						{
							title: 'Time Table',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/attendance/studentAttendance',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Daily Schedule For Employees',
									bullet: 'dot',
									page: '/attendanceNew/dailyScheduleEmployees',
									entPermission: 'viewDailyTimeTableSchedule'
								},
								{
									title: 'Employee Schedule',
									bullet: 'dot',
									page: '/attendanceNew/singleEmployeeSchedule',
									entPermission: 'viewEmployeeTimeTableSchedule'
								},
								{
								title: 'Multiple Faculty Time Table Report',
								bullet: 'dot',
								page: '/attendanceNew/multipleFacultyTimeTableReport',
								entPermission: 'employeeLectureRangeReport',
								},
								{
									title: 'Course Wise Schedule',
									bullet: 'dot',
									page: '/attendanceNew/timeTableCourseWise',
									entPermission: 'viewCourseTimeTableSchedule'
								},
								{
									title: 'Time Table Status',
									bullet: 'dot',
									page: '/attendanceNew/timeTableStatus',
									entPermission: 'timeTableStatusReport'
								},
								{
									title: 'Faculty Availability Report',
									bullet: 'dot',
									page: '/attendanceNew/facultyAvailabilityReport',
									entPermission: 'viewFacultyAvailabilityReport'
								},
							]
						},
						{
							title: 'Student Biometric',
							bullet: 'dot',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Biometric Dashboard',
									bullet: 'dot',
									page: '/attendanceNew/studentBiometricDashboard',
									entPermission: 'viewStudentBiometricDashboard'
								},
								{
									title: 'Biometric Course Report',
									bullet: 'dot',
									page: '/attendanceNew/studentBiometricCourseReport',
									entPermission: 'viewStudentBiometricCourseReport'
								},
								{
									title: 'Biometric Student Report',
									bullet: 'dot',
									page: '/attendanceNew/studentBiometricReport',
									entPermission: 'viewStudentBiometricReport'
								},
								{
								title: 'Attendance Biometric Log Report',
								bullet: 'dot',
								// icon: 'flaticon-coins',
								page: '/attendanceNew/attendanceBiometricPunches',
								entPermission: 'viewStudentBiometricFetchRecordList',
							},
							]
						},
						{
							title: 'Attendance Reports',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/attendance/studentAttendance',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Daily Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/attendanceReport',
									entPermission: 'viewAttendanceReport',
								},
								{
									title: 'Attendance Summary',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/attendanceSummary',
									entPermission: 'viewAttendanceSummary',
								},
								{
									title: 'Course Wise Attendance Report - All Subject',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/courseWiseSummary',
									entPermission: 'viewAllSubjectsAttendanceSummary',
								},
								{
									title: 'Employee Wise Daily Attendance Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/employeeWiseDailyAttendanceReport',
									entPermission: 'viewEmployeeWiseAttendanceReport',
								},
								{
									title: 'Institute Summary',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/instituteSummary',
									entPermission: 'viewInstituteAttendanceSummary',
								},

								{
									title: 'Not Marked Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/notMarkedReport',
									entPermission: 'viewAttendanceNotMarkedReport',
								},
								{
									title: 'Lecture Wise Not Marked Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/lectureWiseNotMarkedReport',
									entPermission: 'viewLectureWiseAttendanceNotMarkedReport',
								},
								{
									title: 'Executive Daily Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/edrAttendanceReport',
									entPermission: 'viewEDRReport',
								},
								{
									title: 'Department Teacher Lecture Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceNew/departmentTeacherLectureReport',
									entPermission: 'departmentTeacherLectureReport',
								},
							{
								title: 'Faculty Load Report',
								bullet: 'dot',
								// icon: 'flaticon-coins',
								page: '/attendanceNew/facultyLoadReport',
								entPermission: 'facultyLoadReport',
							},
							{
								title: 'Student Absentee Report',
								bullet: 'dot',
								page: '/attendanceNew/studentList',
								entPermission: 'viewAbsenteeReport',
							},

							// {
							// 	title: 'Attendance Biometric Log Report',
							// 	bullet: 'dot',
							// 	// icon: 'flaticon-coins',
							// 	page: '/attendanceNew/attendanceBiometricPunches',
							// 	entPermission: 'viewStudentBiometricFetchRecordList',
							// },
							]
						},
						{
							title: 'Leave & Attendance Marks',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/attendance/studentAttendance',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Applied Leave',
									bullet: 'dot',
									page: '/attendanceNew/appliedLeave',
									entPermission: 'viewAppliedLeaveList'
								},
								{
									title: 'Attendance Marks',
									bullet: 'dot',
									page: '/attendanceNew/attendanceMarks',
									entPermission: 'calculateAttendanceMarks'
								},
							]
						},
						{
							title: 'Club Attendance',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page:'/student/strengthReport',
							entPermission: 'viewStudentClubList',
							submenu: [
								{
									title: 'Student Clubs',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/schoolSetup/studentClubs',
									entPermission: 'viewStudentClubList',
								},
								{
									title: 'Club Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/clubAttendance',
									entPermission: 'getListStudentClubAttendance',
								},
								{
									title: 'Club Attendance Marked Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/clubAttendanceMarked',
									entPermission: 'markedReportStudentClubAttendance',
								},
								{
									title: 'Club Attendance Summary Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/clubAttendanceSummaryWise',
									entPermission: 'summaryReportStudentClubAttendance',
								},
							],
						},

					]
				},
				{
					title: 'Attendance V3',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-group',
					//page:'/attendanceV3',
					entPermission: 'getListStudentAttendanceV3',
					submenu: [
						{
							title: 'Student Attendance V3',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							//page: '/attendanceV3',
							entPermission: 'getListStudentAttendanceV3',
							submenu: [
								{
									title: 'Student Attendance ',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceV3',
									entPermission: 'getListStudentAttendanceV3',
								},
								{
									title: 'Marked Attendance Student Wise Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceV3/markedAttendanceReportStudentWise',
									entPermission: 'viewStudentWiseNotMarkedReport',
								},
								{
									title: 'Marked Attendance Teacher Wise Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/attendanceV3/markedAttendanceTeacherWise',
									entPermission: 'viewLectureWiseAttendanceNotMarkedReport',
								},


							]
						},
						{
							title: 'Club Attendance',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page:'/student/strengthReport',
							entPermission: 'viewStudentClubList',
							submenu: [
								{
									title: 'Student Clubs',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/schoolSetup/studentClubs',
									entPermission: 'viewStudentClubList',
								},
								{
									title: 'Club Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/clubAttendance',
									entPermission: 'getListStudentClubAttendance',
								},
								{
									title: 'Club Attendance Marked Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/clubAttendanceMarked',
									entPermission: 'markedReportStudentClubAttendance',
								},
								{
									title: 'Club Attendance Summary Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/clubAttendanceSummaryWise',
									entPermission: 'summaryReportStudentClubAttendance',
								},
							],
						},
						{
							title: 'Student Biometric',
							bullet: 'dot',
							entPermission: 'attendanceModule',
							submenu: [
								{
									title: 'Biometric Dashboard',
									bullet: 'dot',
									page: '/attendanceNew/studentBiometricDashboard',
									entPermission: 'attendanceModule'
								},
								{
									title: 'Biometric Course Report',
									bullet: 'dot',
									page: '/attendanceNew/studentBiometricCourseReport',
									entPermission: 'attendanceModule'
								},
								{
									title: 'Biometric Student Report',
									bullet: 'dot',
									page: '/attendanceNew/studentBiometricReport',
									entPermission: 'attendanceModule'
								},
								{
								title: 'Attendance Biometric Log Report',
								bullet: 'dot',
								// icon: 'flaticon-coins',
								page: '/attendanceNew/attendanceBiometricPunches',
								entPermission: 'viewStudentBiometricFetchRecordList',
							},
							]
						},
					]
				},
				{
					title: 'Examination',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-calendar',
					// page:'/studentAttendance',
					entPermission: 'examinationModule',
					submenu: [
						{
							title: 'Marks Entry',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/examination/assessmentsMarks',
							entPermission: 'examinationModule',
							submenu: [
								{
									title: 'Assessment Wise Marks Entry',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/assessmentsMarks',
									entPermission: 'viewAssessmentMarks',
								},
								{
									title: 'Student Wise Marks Entry',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/assessmentsMarksStudentWise',
									entPermission: 'viewAssessmentMarksByStudent',
								},
								{
									title: 'Subject Wise Marks Entry',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/marksEntryMultipleAssessment',
									entPermission: 'viewAssessmentMarks',
								},
								{
									title: 'Student Wise Marks Entry V2',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/assessmentsMarksStudentWiseV2',
									entPermission: 'viewAssessmentMarksByStudentv2',
								},
								{
									title: 'Optional & Additional Subjects Marks Entry', 
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/optionalAdditionalSubjectsMarks',
									entPermission: 'optionalAdditionalMarksEntry', //permission suggested by ayush and shobhit to change on page menu  in jan25Part1 on 20-2-2025
								},
								{
									title: 'Student Wise Skills Entry',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/studentMarksEntrySkillWise',
									entPermission: 'viewAssessmentMarksBySkill',
								},
								{
									title: 'Club Wise Marks Entry',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/clubWiseMarksEntry',
									entPermission: 'viewAssessmentMarksBySkill',
								}
							],

						},
						{
							title: 'Class Test',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/examination/assessmentsMarks',
							entPermission: 'examinationModule',
							submenu: [
								{
									title: 'Class Test',
									bullet: 'dot',
									// page:'/analytics/partnerInstitute',
									page: '/examination/classTestEntry',
									entPermission: 'viewClassTest',
								},
								{
									title: 'Class Test Green Sheet',
									bullet: 'dot',
									// page:'/analytics/partnerInstitute',
									page: '/examination/classTestGreenSheet',
									entPermission: 'viewClassTestGreenSheet',
								},
								{
									title: 'Class Test Count Report',
									bullet: 'dot',
									// page:'/analytics/partnerInstitute',
									page: '/examination/classTestCountReport',
									entPermission: 'getClassTestCountReport',
								}


							]
						},
						{
							title: 'Report',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/examination/assessmentsMarks',
							entPermission: 'examinationModule',
							submenu: [
								{
									title: 'Assessment Wise Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/assessmentsWiseReport',
									entPermission: 'viewMarksByCourse',
								},
								{
									title: 'Green Sheet',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/greenSheet',
									entPermission: 'viewGreenSheet',
								},
								{
									title: 'University Green Sheet',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/universityGreenSheet',
									entPermission: 'viewGreenSheet',
								},
								{
									title: 'Report Card',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/reportCardData',
									entPermission: 'viewReportCard',
								},
								{
									title: 'Report Card V2',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/reportCardDatav2',
									entPermission: 'viewReportCardv2',
								},
								{
									title: 'Detailed Marks Certificate',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/assessmentsMarksStudentWiseV3',
									entPermission: 'viewAssessmentMarksByStudentv2',
								},
								{
									title: 'Pending Assessment Marks',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/pendingAssessmentMarks',
									entPermission: 'viewPendingAssessmentMarks',
								},
								{
									title: 'Result At A Glance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/resultAtAGlance',
									entPermission: 'viewCourseResultReport',
								},
								// {
								// 	title: 'Exam Registration',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page:'/examination/examRegistration',
								// 	entPermission: 'viewExamRegistrationList',
								// },
								// {
								// 	title: 'Issue Admit Card',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page:'/examination/issueAdmitCard',
								// 	entPermission: 'viewExamRegistrationList',
								// },
								{
									title: 'Exam Analysis Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/examAnalysisReport',
									entPermission: 'viewExamRegistrationList',
								},
								{
									title: 'Detailed Marks Certificate Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/detailedMarksCertificateReport',
									entPermission: 'viewExamRegistrationList',
								},

							]
						},

						{
							title: 'Examination Insights',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/insights/examinationInsights',
							entPermission: 'insightsModule',
							submenu: [
								{
									title: 'Student Wise Insights',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/insights/examinationInsights',
									entPermission: 'examinationInsights',
								},
								{
									title: 'Course Wise Insights',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/examination/cbseResult',
									entPermission: 'getClassAssessmentStats',
								},
							]
						},
						{
							title: 'COE Examination',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/schoolDiary/assignment',
							entPermission: 'examinationModule',
							submenu: [
						{
							title: 'Subject Wise Report',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							page: '/examination/subjectWiseReport',
							entPermission: 'viewExamSubjectReport',
						},
						{
							title: 'Date Sheet Report',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							page: '/examination/dateSheetReport',
							entPermission: 'viewExamDateSheet',
						},
						{
							title: 'Seat Schedule Report',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							page: '/examination/seatScheduleReport',
							entPermission: 'viewExamSeatScheduleReport',
						},
						]
						}
					],

				},
				{
					title: 'COE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-calendar',
					// page:'/studentAttendance',
					entPermission: 'coeModule',
					submenu: [
						{
							title: 'Exam Master',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/coe/',
							entPermission: 'coeModule',
							submenu:[
								{
									title: 'Exam Master',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/coe/examMaster',
									entPermission: 'viewExamMasterList',
								},
								{
									title: 'Datesheet',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/coe/datesheet',
									entPermission: 'viewExamDateSheet',
								},
								{
									title: 'Exam Configuration',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/coe/examConfiguration',
									entPermission: 'viewCOEConfiguration',
								},
							],
						},
						{
							title: 'Exam Registration',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/coe/',
							entPermission: 'coeModule',
							submenu: [
								{
									title: 'Exam Registration',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page:'/coe/studentWiseExamRegistration',
									entPermission: 'viewExamRegistration',
								},
								{
									title: 'Approve Exam Registration',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page:'/coe/subjectWiseExamRegistration',
									entPermission: 'viewExamRegistration',
								},

								{
									title: 'Pending Registration Report',
									bullet: 'dot',
									page:'/coe/pendingRegistrationReport',
									entPermission: 'viewExamRegistrationList',
								},
								{
									title: 'Transactions List',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page:'/coe/coeTransactionList',
									entPermission: 'viewCOETransactionList',
								},
								{
									title: 'Issue Admit Card',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page:'/coe/issueAdmitCard',
									entPermission: 'viewExamAdmitCard',
								},
							],
						},
						{
							title: 'Exam Day Operation',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/coe/',
							entPermission: 'coeModule',
							submenu:[
								// {
								// 	title: 'Exam Registration',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page:'/coe/studentWiseExamRegistration',
								// 	entPermission: 'viewExamRegistrationList',
								// },
								// {
								// 	title: 'Approve Exam Registration',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page:'/coe/subjectWiseExamRegistration',
								// 	entPermission: 'viewExamRegistrationList',
								// },
								{
									title: 'Daily Exam Dashboard',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/coe/dashboard',
									entPermission: 'viewDailyMonitoring',
								},
								{
									title: 'Exam Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page:'/coe/examAttendance',
									entPermission: 'saveExamAttendance',
								},
								{
									title: 'Exam Attendance Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/coe/dailyExamAttendanceSummaryReport',
									entPermission: 'viewExamAttendanceSummary',
								},
								{
									title: 'Attendance Sheet',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/coe/attendanceSheetCourseWise',
									entPermission: 'viewExamAttendanceSummary',
								},
								{
									title: 'Question CO Mapping',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page:'/coe/coeMaster/questionCOMapping',
									entPermission: 'viewQuestionCOMappingList',
								}
							],

						},
						{
							title: 'Re-Evaluation',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/coe/',
							entPermission: 'coeModule',
							submenu:[
								{
									title: 'Collect Re-Evaluation',
									bullet: 'dot',
									page:'/coe/collectReEvaluation',
									entPermission: 'viewExamRegistration',
								},
								{
									title: 'Re-Evaluation Marks Entry',
									bullet: 'dot',
									page: '/coe/reEvaluationMarksEntry',
									entPermission: 'saveReEvaluationMarks',
								},
							]
						},
						{
							title: 'Marks Entry',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/coe/',
							entPermission: 'coeModule',
							submenu:[
								// {
								// 	title: 'Validations/Preferences',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page: '/coe/validationsPreferences',
								// 	entPermission: 'viewCOEMaster',
								// },
								// {
								// 	title: 'Exam Calendar',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page: '/coe/examCalendar',
								// 	entPermission: 'viewExamCalendarList',
								// },
								// {
								// 	title: 'Exam Master',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page: '/coe/examMaster',
								// 	entPermission: 'viewExamMasterList',
								// },
								{
									title: 'Admin Marks Entry',
									bullet: 'dot',
									page: '/coe/adminMarksEntry',
									entPermission: 'getMarksByMaskingId',
								},
								{
									title: 'Theory Marks Entry',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/coe/marksEntry',
									entPermission: 'getMarksByMaskingId',
								},
								{
									title: 'Practical Marks Entry',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/coe/practicalMarksEntry',
									entPermission: 'saveCOEPracticalMarks',
								},
								{
									title: 'Internal Marks Entry',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/coe/internalMarksEntry',
									entPermission: 'saveCOEInternalMarks',
								},
								{
									title: 'Internal Marks Approve',
									bullet: 'dot',
									page: '/coe/greenSheet',
									entPermission: 'editExamRegistration',
								},
								{
									title: 'Pending Marks Entry Report',
									bullet: 'dot',
									page:'/coe/pendingMarksEntryReport',
									entPermission: 'pendingMarksEntryReport',
								},
								{
									title: 'Grace Marks',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page:'/coe/graceMarks',
									entPermission: 'getGraceMarksCOE',
								},
							],

						},
						{
							title: 'Result',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/coe/',
							entPermission: 'coeModule',
							submenu:[
								{
									title: 'Subject Wise Marks Report',
									bullet: 'dot',
									page:'/coe/subjectWiseMarksReport',
									entPermission: 'subjectMarksReportCOE',
								},
								{
									title: 'Type Wise Marks Report',
									bullet: 'dot',
									page:'/coe/subjectTypeWiseMarksReport',
									entPermission: 'subjectTypeWiseMarksReportCOE',
								},
								{
									title: 'Result Analysis Report',
									bullet: 'dot',
									page:'/coe/resultAnalysisReport',
									entPermission: 'resultAnalysisReportCOE',
								},
								{
									title: 'Result Declare',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/coe/resultDeclare',
									entPermission: 'coeResultDeclare',
								},
								{
									title: 'Result Sheet',
									bullet: 'dot',
									page:'/coe/resultSheet',
									entPermission: 'resultSheetCOE',
								},
								{
									title: 'Revaluation Result Sheet',
									bullet: 'dot',
									page:'/coe/revaluationResultSheet',
									entPermission: 'resultSheetCOE',
								},
								{
									title: 'HOD Result Sheet',
									bullet: 'dot',
									page:'/coe/hodResultSheet',
									entPermission: 'hodCOEResultSheet',
								},
								{
									title: 'Combined Result Sheet',
									bullet: 'dot',
									page:'/coe/combinedResultSheet',
									entPermission: 'resultSheetCOE',
								},
								{
									title: 'Digi Locker Report',
									bullet: 'dot',
									page:'/coe/digiLockerReport',
									entPermission: 'resultSheetCOE',
								},
								{
									title: 'Student DMC',
									bullet: 'dot',
									page:'/coe/studentDmc',
									entPermission: 'studentDMC',
								},
								{
									title: 'Combined Student DMC',
									bullet: 'dot',
									page:'/coe/combinedStudentDmc',
									entPermission: 'studentDMC',
								},
							],

						},
						// {
						// 	title: 'Transaction',
						// 	bullet: 'dot',
						// 	// icon: 'flaticon-coins',
						// 	// page: '/coe/',
						// 	entPermission: 'coeModule',
						// 	submenu:[
						// 		{
						// 			title: 'COE Transaction List',
						// 			bullet: 'dot',
						// 			// icon: 'flaticon-coins',
						// 			page:'/coe/coeTransactionList',
						// 			entPermission: 'viewCOETransactionList',
						// 		},
						// 	],

						// },
						// {
						// 	title: 'COE Examination',
						// 	bullet: 'dot',
						// 	// icon: 'flaticon2-list-2',
						// 	// page: '/schoolDiary/assignment',
						// 	entPermission: 'viewExamSeatScheduleReport',
						// 	submenu:[
						// 		{
						// 			title: 'Subject Wise Report',
						// 			bullet: 'dot',
						// 			// icon: 'flaticon2-list-2',
						// 			page: '/examination/subjectWiseReport',
						// 			entPermission: 'viewExamSubjectReport',
						// 		},
						// 		{
						// 			title: 'Date Sheet Report',
						// 			bullet: 'dot',
						// 			// icon: 'flaticon2-list-2',
						// 			page: '/examination/dateSheetReport',
						// 			entPermission: 'viewExamSeatScheduleReport',
						// 			// entPermission: 'viewExamDateSheet',
						// 		},
						// 		{
						// 			title: 'Seat Schedule Report',
						// 			bullet: 'dot',
						// 			// icon: 'flaticon2-list-2',
						// 			page: '/examination/seatScheduleReport',
						// 			entPermission: 'viewExamSeatScheduleReport',
						// 		},
						// 	]
						// },
					],
				},
				{
					title: 'Feedback From Student',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-report',
					// page:'/schoolDiary',
					entPermission: 'viewFeedbackMaster',
					submenu: [
						{
							title: 'Feedback From Student',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/schoolDiary/assignment',
							entPermission: 'viewFeedbackMaster',
							submenu: [
								{
									title: 'Feedback from Student',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolSetup/feedbackStudent',
									entPermission: 'viewFeedbackFromStudentList',
								},
								{
									title: 'Feedback from Student Report Dashboard',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/feedbackDashboard',
									entPermission: 'courseWiseFeedbackFromStudentCount',
								},
								{
									title: 'Manage Student Feedback',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/manageStudentFeedback',
									entPermission: 'deleteFeedbackFromStudentResponse',
								},
							]
						},
						{
							title: 'Feedback From Student Reports',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/schoolDiary/assignment',
							entPermission: 'viewFeedbackMaster',
							submenu: [
								{
									title: 'All Faculty Feedback Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/allFacultyFeedbackReport',
									entPermission: 'allFacultyFeedbackReport',
								},
								{
									title: 'Course Wise Faculty Average Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/courseWiseFacultyAverageReport',
									entPermission: 'courseWiseFacultyAverageReport',
								},
								{
									title: 'Individual Faculty Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/individualFacultyReport',
									entPermission: 'individualFacultyReport',
								},
								{
									title: 'Feedback Summary Report (New)',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/classSectionWiseFeedbackSummaryReport',
									entPermission: 'questionWiseFeedbackSummaryReport',
								},
								{
									title: 'Section Wise Feedback Summary Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/sectionWiseFeedbackSummaryReport',
									entPermission: 'sectionWiseFeedbackSummaryReport',
								},
								{
									title: 'Facility Feedback Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/facilityFeedbackReport',
									entPermission: 'facilityFeedbackReport',
								},
								{
									title: 'Student Submission Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/studentSubmissionReport',
									entPermission: 'studentSubmissionReport',
								},
								{
									title: 'Feedback Summary Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/feedbackSummaryReport',
									entPermission: 'facultyFeedbackQuestionWiseReport',
								},
								{
									title: 'Faculty Wise Question Average Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/feedbackFromStudent/facultyWiseQuestionAverageReport',
									entPermission: 'facultyFeedbackQuestionWiseReport',
								},
							]
						}
					]
				},
				{
					title: 'School Diary',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-report',
					// page:'/schoolDiary',
					entPermission: 'viewSchoolDiaryList',
					submenu: [
						{
							title: 'School Diary',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/schoolDiary/assignment',
							entPermission: 'viewSchoolDiaryList',
							submenu: [
								{
									title: 'Assignment',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/assignment',
									entPermission: 'viewAssignmentList',
								},
								{
									title: 'Homework',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/homework',
									entPermission: 'viewHomeworkList',
								},
								{
									title: 'Homework New',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/homeworkNew',
									entPermission: 'viewHomeworkList',
								},
								{
									title: 'Circular',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/circular',
									entPermission: 'viewCircularList',
								},
								{
									title: 'Notice',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/notice',
									entPermission: 'viewNoticeList',
								},
								{
									title: 'Syllabus',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/syllabus',
									entPermission: 'viewSyllabusList',
								},
								{
									title: 'Date Sheet',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/dateSheet',
									entPermission: 'viewDateSheetList',
								},
								{
									title: 'E-Learning',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/eLearning',
									entPermission: 'viewELearningList',
								},
								{
									title: 'Time Table',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/timeTable',
									entPermission: 'viewDateSheetList',
								},
								{
									title: 'Homework Not Sent Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/schoolDiary/homeWorkNotSendReport',
									entPermission: 'homeworkReport',
								},
							]
						}
					]
				},
				{
					title: 'Learning Management',
					bullet: 'dot',
					icon: 'flaticon-coins',
					// page: '/learningManagement',
					entPermission: 'learningManagementModule',
					submenu: [
						{
							title: 'Learning Management',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/learningManagement',
							entPermission: 'learningManagementModule',
							submenu: [
								{
									title: 'Learning Management',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/learningManagement',
									entPermission: 'viewLearningManagementList',
								}
							]
						},
					]
				},
				{
					title: 'Lesson Plan',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-analytics',
					//page:'/lessonCrud',
					entPermission: 'viewLessonPlanList',
					submenu: [
						{
							title: 'Lesson Plan',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/lessonManagement',
							entPermission: 'viewLessonPlanList',
							submenu: [
								{
									title: 'Lesson Management',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/lessonManagement',
									entPermission: 'viewLessonPlanList',
								},
								{
									title: 'Subject Wise Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/lessonManagement/subjectWiseReport',
									entPermission: 'viewSubjectWiseLessonReport',
								},
							]
						}
					]
				},
				{
					title: 'HRM',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-team',
					//page:'/hrm',
					entPermission: 'hrmModule',
					submenu: [
						{
							title: 'HRM',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/hrm/employee',
							entPermission: 'hrmModule',
							submenu: [
								{
									title: 'Employee',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employee',
									entPermission: 'viewEmployeeList',
								},
								{
									title: 'Manage Employee',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/manageEmployee',
									entPermission: 'manageEmployee',
								},
								{
									title: 'Employee Entitled Leaves',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeEntitledLeaves',
									entPermission: 'viewEmployeeEntitledLeave',
								},
								{
									title: 'Attendance Calendar',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeAttendanceCalendar',
									entPermission: 'getEmployeeAttendanceCalendar',
								},
								{
									title: 'Assign Salary Template',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/assignSalaryTemplateToEmployee',
									entPermission: 'bulkAssignEmployeeSalaryTemplate',
								},
								{
									title: 'Manage Salary Templates',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/manageSalaryTemplates',
									entPermission: 'viewEmployeeSalaryList',
								},
							]
						},
						{
							title: 'Employee Reports',
							bullet: 'dot',
							// page:'/analytics/partnerInstitute',
							entPermission: 'viewEmployeeReport',
							submenu: [
								{
									title: 'Employee Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeReport',
									entPermission: 'viewEmployeeList',
								},
								{
									title: 'Leave Type Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeEntitledLeaveTypeReport',
									entPermission: 'viewEmployeeEntitledLeaveTypeReport',
								},

								{
									title: 'Attendance Time Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeAttendanceReport',
									entPermission: 'viewDailyEmployeeAttendanceReport',
								},
								{
									title: 'Attendance Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/attendanceReport',
									entPermission: 'viewDailyEmployeeAttendanceReport',
								},
								{
									title: 'Daily Attendance Report Department Wise',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeDailyAttendanceReport',
									entPermission: 'dailyAttendanceReportDepartmentWise',
								},
								{
									title: 'Absentees & Late Arrival Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/lateArrivalAbsenteeReport',
									entPermission: 'viewDailyEmployeeAttendanceReport',
								},
								{
									title: 'Leave Approval Report ',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/appliedLeaves',
									entPermission: 'viewEmployeeLeaveApprovalReport',
								},
								{
									title: 'Compensatory Leave Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/compensatoryLeaveRequests',
									entPermission: 'viewEmployeeCompensatoryLeaveList',
								},


								{
									title: 'Attendance Logs',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/dailySchedulerLogs',
									entPermission: 'getEmployeeAttendanceDailySchedulerLogs',
								},
								{
									title: 'Employee Promotion',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeePromotion',
									entPermission: 'viewEmployeePromotionList',
								},
								{
									title: 'Leave Type Count Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/departmentWiseLeaveReport',
									entPermission: 'leaveBookedAndBalanceReport',
								},
								
								{
									title: 'Working Hour Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/workingHourReport',
									entPermission: 'viewEmployeeWorkingTimeReport',
								},
							]
						},
						{
							title: 'Employee Attendance',
							bullet: 'dot',
							// page:'/analytics/partnerInstitute',
							entPermission: 'viewEmployeeAttendanceMenu',
							submenu: [
								{
									title: 'Mark Attendance Day Wise',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/markEmployeeAttendance',
									entPermission: 'addEmployeeAttendance',
								},
								{
									title: 'Mark Attendance Month Wise',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeAttendanceMonthWise',
									entPermission: 'addEmployeeAttendance',
								},
								{
									title: 'Biometric Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeAttendance',
									entPermission: 'editEmployeeAttendance',
								},

								{
									title: 'Attendance Regularization',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeAttendanceRegularization',
									entPermission: 'viewEmployeeAttendanceRegularizationList',
								}
							]
						},
						{
							title: 'Process Salary Report',
							bullet: 'dot',
							// page:'/analytics/partnerInstitute',
							entPermission: 'processEmployeeSalary',
							submenu: [
								{
									title: 'Compute Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/processSalary',
									entPermission: 'processEmployeeSalary',
								},
								{
									title: 'Compute Attendance Payable Days',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/processSalaryPayable',
									entPermission: 'computeAttendanceViaPayableDays',
								},
								{
									title: 'Salary Summary Month Wise',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/salarySummary',
									entPermission: 'viewEmployeeSalaryMonthWise',
								},
							]
						},
						{
							title: 'Salary Reports',
							bullet: 'dot',
							// page:'/analytics/partnerInstitute',
							entPermission: 'processEmployeeSalary',
							submenu: [

								{
									title: 'Salary Slip',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeSalarySummary',
									entPermission: 'viewEmployeeSalaryList',
								},
								{
									title: 'Employee Salary Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeSalaryReport',
									entPermission: 'viewEmployeeSalaryReport',
								},
								{
									title: 'Employee Salary Register',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeSalaryRegister',
									entPermission: 'viewEmployeeSalaryMonthlyReport',
								},
								{
									title: 'Employee Salary Report - Multiple Months',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/employeeSalarySummaryMonthWise',
									entPermission: 'viewEmployeeSalaryMonthlyReport',
								},
								// {
								// 	title: 'Assign Salary Template',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page: '/hrm/assignSalaryTemplateToEmployee',
								// 	entPermission: 'bulkAssignEmployeeSalaryTemplate',
								// },
								{
									title: 'Arrear Salary Report ',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/arrearSalaryReport',
									entPermission: 'viewArrearSalaryReport',
								},
								// {
								// 	title: 'Contract Assigned Report',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon-coins',
								// 	page: '/hrm/contractAssignedReport',
								// 	entPermission: 'bulkAssignEmployeeSalaryTemplate',
								// },
								{
									title: 'Earning & Deduction Register',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/earningDeductionRegister',
									entPermission: 'bulkAssignEmployeeSalaryTemplate',
								},
								{
									title: 'PF Challan Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hrm/pfChallanReport',
									entPermission: 'viewPFChallanReport',
								},
							]
						}

						// {
						// 		title: 'Payroll',
						// 		bullet: 'dot',
						// 		// icon: 'flaticon-coins',
						// 		// page: '/hrm/payroll',
						// 		entPermission: 'payrollModule',
						// 		submenu:[
						// 			{
						// 			title: 'Payroll',
						// 			bullet: 'dot',
						// 			// icon: 'flaticon-coins',
						// 			page: '/hrm/payroll',
						// 			entPermission: 'payrollModule',
						// 			}
						// 		]

						// },


					]
				},
				{
					title: 'Users',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-group',
					// page:'/reportFile',
					entPermission: 'viewUser',
					submenu: [
						{
							title: 'Users',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/users',
							entPermission: 'viewUser',
							submenu: [
								{
									title: 'Users',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/users',
									entPermission: 'viewUserList'
								},
								{
									title: 'Task Management',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/taskManagement',
									entPermission: 'viewUserTaskList',
								},
							]
						},
					]
				},




				{
					title: 'Library',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-book',
					page: '/library',
					entPermission: 'libraryModule',
					submenu: [
						{
							title: 'Library',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/library/libraryBook',
							entPermission: 'libraryModule',
							submenu: [
								{
									title: 'Books',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/libraryBook',
									entPermission: 'viewLibraryBookList',
								},
								{
									title: 'Issue Book',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/issueBook',
									entPermission: 'issueLibraryBook',
								},
								{
									title: 'Issue Book Course Wise',
									bullet: 'dot',
									page: '/library/issueBookCourseWise',
									entPermission: 'getIssueRecordsByReceiverId'

								},
								{
									title: 'Issued Books',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/issueRecords/libraryDetails',
									entPermission: 'getAllLibraryIssueRecords',
								},



								{
									title: 'Stock Verify',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/stockVerify',
									entPermission: 'libraryStockVerify',
								},
								{
									title: 'Library Visitor',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/libraryVisitor',
									entPermission: 'viewLibraryVisitList',
								},
								{
									title: 'Digital Library',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/digitalLibrary',
									entPermission: 'viewDigitalLibraryList',
								},
							]
						},

						// {
						// 	title: 'Transaction',
						// 	bullet: 'dot',
						// 	// icon: 'flaticon2-list-2',
						// 	// page: '/fee/transactionList',
						// 	entPermission: 'libraryModule',
						// 	submenu:[

						// 	]
						// },
						{
							title: 'Serial Management',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							page: '/library/quickReport',
							entPermission: 'viewLibrarySerialSubscriptionList',
							submenu: [
								{
									title: 'Serial Subscription',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/serialSubscription',
									entPermission: 'viewLibrarySerialSubscriptionList',
								},

								{
									title: 'Serial Collection',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/serialCollection',
									entPermission: 'viewLibrarySerialCollectionList',
								},
								{
									title: 'Serial Collection Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/serialCollectionReport',
									entPermission: 'viewLibrarySerialCollectionReport'
								},
							]
						},
						{
							title: 'Library Reports',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							page: '/library/libraryReports',
							entPermission: 'viewLibraryBookList',
							submenu: [
								{
									title: 'Library Reports',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/libraryReports',
									entPermission: 'viewLibraryBookList',
								},
								{
									title: 'Library Issued Books Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/libraryIssuedReports',
									entPermission: 'getAllLibraryIssueRecords',
								},
								{
									title: 'Library Collection Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/library/libraryTransactionList',
									entPermission: 'viewLibraryTransactionList',
								},
								{
									title: 'Quick Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/quickReport',
									entPermission: 'countLibraryBooks'
								},
								{
									title: 'Date Wise Issue/Return Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/dateWiseIssueReport',
									entPermission: 'dateWiseLibraryIssueReport',
								},
								{
									title: 'Member Type Wise Issued Count',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/memberTypeWiseIssuedCount',
									entPermission: 'countIssuedBooksCountMemberWise'
								},
								{
									title: 'Title & Subtitle Category Summary Report',
									bullet: 'dot',
									page:'/library/titleSubtitleCategorySummaryReport',
									entPermission: 'libraryBookAnalysis'
	
								},
								{
									title: 'WebOPAC Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/library/webOPACReport',
									entPermission: 'viewWebOPAC'
								}
							]
						},
						{
							title: 'WebOPAC',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/fee/transactionList',
							entPermission: 'viewWebOPAC',
							submenu: [
								{
									title: 'WebOPAC',
									bullet: 'dot',
									// icon: 'flaticon3-analytics',
									page: `/web-opac`,
									entPermission: 'viewWebOPAC',
								},
							]
						},

					]
				},

				{
					title: 'FrontDesk',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-group',
					// page:'/reportFile',
					entPermission: 'frontDeskModule',
					submenu: [
						{
							title: 'Front Desk',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/frontDesk/visitor',
							entPermission: 'frontDeskModule',
							submenu: [
								{
									title: 'Visitor',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/frontDesk/visitor',
									entPermission: 'viewVisitorList',
								},
								{
									title: 'Gate Pass',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/frontDesk/gatePass',
									entPermission: 'viewGatePassList',
								},
								{
									title: 'Hostel Gate Pass QR',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/frontDesk/hostelGatePassQr',
									entPermission: 'viewHostelGatePassList',
								},
								{
									title: 'Gate Pass QR',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/frontDesk/gatePassQr',
									entPermission: 'viewGatePassList',
								},
							]
						}
					]
				},
				// {
				// 	title: 'Mess Management',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'flaticon3-group',
				// 	// page:'/reportFile',
				// 	entPermission: 'frontDeskModule',
				// 	submenu: [
				// 		{
				// 			title: 'Mess Management',
				// 			bullet: 'dot',
				// 			// icon: 'flaticon-coins',
				// 			// page: '/frontDesk/visitor',
				// 			entPermission: 'getMessMangementDashboard',
				// 			submenu:[
				// 		{
				// 			title: 'Dashboard',
				// 			bullet: 'dot',
				// 			// icon: 'flaticon-coins',
				// 			page: '/messManagement/messManagementDashboard',
				// 			entPermission: 'getMessMangementDashboard',
				// 		},
				// 		{
				// 			title: 'Mess Attendance',
				// 			bullet: 'dot',
				// 			// icon: 'flaticon-coins',
				// 			page: '/messManagement/messAttendance',
				// 			entPermission: 'viewMessAttendanceList',
				// 		},
				// 		{
				// 			title: 'Meal Type',
				// 			bullet: 'dot',
				// 			// icon: 'flaticon-coins',
				// 			page: '/messManagement/messManagementFoodType',
				// 			entPermission: 'viewFoodTypeList',
				// 		},
				// 		{
				// 			title: 'Summary Report',
				// 			bullet: 'dot',
				// 			// icon: 'flaticon-coins',
				// 			page: '/messManagement/messManagementSummaryReport',
				// 			entPermission: 'messAttendanceSummaryReport',
				// 		},
				// 		{
				// 			title: 'Detailed Report',
				// 			bullet: 'dot',
				// 			// icon: 'flaticon-coins',
				// 			page: '/messManagement/messManagementDetailedReport',
				// 			entPermission: 'messAttendanceDetailedReport',
				// 		},
				// 	]
				// }
				// 	]
				// },


				{
					title: 'Communication',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-report',
					page: '/communication',
					entPermission: 'communicationModule',
					submenu: [
						{
							title: 'Communication',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/communication/sendSMS',
							entPermission: 'communicationModule',
							submenu: [
								{
									title: 'Send Text SMS',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/communication/sendSMS',
									entPermission: 'sendSMSCommunication',
								},
								{
									title: 'Send Email',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/communication/sendEmail',
									entPermission: 'sendEmailCommunication',
								},
								{
									title: 'Send Whatsapp Message',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/communication/webWhatsappMessage',
									entPermission: 'sendWhatsAppWebCommunication',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/communication/report',
									entPermission: 'viewCommunicationReport',
									// translate: 'MENU.DASHBOARD',
								},
								// {
								// 	title: 'Employee Communication Report',
								// 	bullet: 'dot',
								// 	// icon: 'flaticon2-list-2',
								// 	page: '/communication/employeeReport',
								// 	entPermission: 'viewEmployeeCommunicationReportList',
								// 	// translate: 'MENU.DASHBOARD',
								// },
								{
									title: 'Employee Announcement',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/communication/employeeAnnouncement',
									entPermission: 'viewEmployeeAnnouncementList',
									// translate: 'MENU.DASHBOARD',
								},
								{
							title: 'WhatsApp Chat',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							page: '/chatBot/config',
							entPermission:'listChatBotMessage',
						},
					]
						}
					]
				},
				// {
				// 	title: 'Communication V2',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'flaticon3-report',
				// 	page: '/communicationv2',
				// 	entPermission: 'communicationModule',
				// },


				{
					title: 'Transport',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-report',
					//page:'/transportAttendance',
					entPermission: 'viewTransportReport',
					submenu: [
						{
							title: 'Transport',
							bullet: 'dot',
							// page: '/transportAttendance',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewTransportReport',
							submenu: [
								{
									title: 'Assign Transport',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/transportAttendance/assignTransport',
									entPermission: 'assignRouteToStudent',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Transport Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/transportReport',
									entPermission: 'viewTransportReport',
								},
								{
									title: 'Transport Occupancy',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/student/transportOccupancy',
									entPermission: 'viewTransportOccupancyReport',
								},

								{
									title: 'Transport Attendance ',
									bullet: 'dot',
									page: '/transportAttendance',
									// icon: 'flaticon2-list-2',
									// page: '/feeReports',
									entPermission: 'viewTransportAttendance',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Transport Attendance QR ',
									bullet: 'dot',
									page: '/transportAttendance/transportAttendanceQr',
									// icon: 'flaticon2-list-2',
									// page: '/feeReports',
									entPermission: 'viewTransportAttendanceByQR',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Transport QR Generator',
									bullet: 'dot',
									page: '/transportAttendance/transportQrGenerator',
									// icon: 'flaticon2-list-2',
									// page: '/feeReports',
									entPermission: 'transportStudent',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Transport Attendance Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/transportAttendance/transportAttendanceReport',
									entPermission: 'viewDailyAttendanceTransportReport',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Daily Summary Route Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/transportAttendance/dailySummaryRouteWise',
									entPermission: 'viewDailyTransportAttendanceReport',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Transport Unmarked Attendance Report',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/transportAttendance/transportUnmarkedAttendanceReport',
									entPermission: 'viewUnmarkedTransportAttendanceReport',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Transport Due Fee Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/fee/transportDueFeeReport',
									entPermission: 'viewTransportReport',
								},
								{
									title: 'Daily Transport Collection',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/fee/dailyTransportCollection',
									entPermission: 'dailyTransportCollection',
								},
								{
									title: 'Transport Students Daily Gate Pass Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/transportAttendance/gatePassReport',
									entPermission: 'gatePassTransportReport',
								},
								{
									title: 'Transport Marked Attendance Report',
									bullet: 'dot',
									page: '/transportAttendance/routeTravelReport',
									entPermission: 'viewDailyTransportAttendanceReport',
								},
					]}
					]
				},
				{
					title: 'Hostel',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-analytics',
					//page: '/hostelAttendance',
					entPermission: 'viewHostelMaster',
					submenu: [
						{
							title: 'Hostel ',
							bullet: 'dot',
							// page: '/hostelAttendance',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewHostelMaster',
							// translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Hostel Report',
									bullet: 'dot',
									page: '/hostelAttendance/hostelReport',
									// icon: 'flaticon2-list-2',
									// page: '/feeReports',
									entPermission: 'viewHostelReport',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Occupancy Report',
									bullet: 'dot',
									page: '/hostelAttendance/occupancyReport',
									// icon: 'flaticon2-list-2',
									// page: '/feeReports',
									entPermission: 'viewHostelOccupancyReport',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Hostel Attendance ',
									bullet: 'dot',
									page: '/hostelAttendance',
									// icon: 'flaticon2-list-2',
									// page: '/feeReports',
									entPermission: 'getHostelAttendanceStudents',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Hostel QR Generator',
									bullet: 'dot',
									page: '/hostelAttendance/hostelQrGenerator',
									// icon: 'flaticon2-list-2',
									// page: '/feeReports',
									entPermission: 'hostelStudent',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Live Hostel Attendance',
									bullet: 'dot',
									page: '/hostelAttendance/hostelLiveAttendance',
									// icon: 'flaticon2-list-2',
									// page: '/feeReports',
									entPermission: 'viewHostelLiveAttendanceReport',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Hostel Attendance Report',
									bullet: 'dot',
									page: '/hostelAttendance/hostelAttendanceReport',
									// icon: 'flaticon2-list-2',
									// page: '/feeReports',
									entPermission: 'viewHostelAttendanceReport',
									// translate: 'MENU.DASHBOARD',
								},
								{
									title: 'Hostel UnMarked Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hostelAttendance/hostelUnMarkedReport',
									entPermission: 'viewUnmarkedHostelAttendanceReport',
								},
								{
									title: 'Hostel Gate Pass',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/hostelAttendance/hostelGatePass',
									entPermission: 'viewHostelGatePassList',
								},
							]
						},
						{
							title: 'Mess Management',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/frontDesk/visitor',
							entPermission: 'getMessMangementDashboard',
							submenu: [
								{
									title: 'Mess Attendance',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/messManagement/messAttendance',
									entPermission: 'viewMessAttendanceList',
								},
								{
									title: 'Summary Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/messManagement/messManagementSummaryReport',
									entPermission: 'messAttendanceSummaryReport',
								},
								{
									title: 'Detailed Report',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/messManagement/messManagementDetailedReport',
									entPermission: 'messAttendanceDetailedReport',
								},
								{
									title: 'Meal Feedback Report',
									bullet: 'dot',
									page: '/messManagement/messMealFeedbackReport',
									entPermission: 'messMealFeedbackReport',
								},
							]
						}

					]
				},
				{
					title: 'Advanced',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-jigsaw',
					page: '/advancedSetup',
					entPermission: 'advancedModule',
					submenu: [
						{
							title: 'Advanced',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/advancedSetup/resourcePerson',
							entPermission: 'advancedModule',
							submenu: [
								{
									title: 'Alumni',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/advancedSetup/alumni',
									entPermission: 'viewAlumniList',
								},
								{
									title: 'Seminar',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/advancedSetup/seminar',
									entPermission: 'viewSeminarList',
								},
								{
									title: 'Events',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/advancedSetup/event',
									entPermission: 'viewEventList',
								},

								{
									title: 'Research Publication',
									bullet: 'dot',
									icon: 'flaticon-information',
									page: '/advancedSetup/researchPublication',
									entPermission: 'viewResearchPublicationList',
								},
						{
									title: 'Book/Chapter/Proceeding',
									bullet: 'dot',
									icon: 'flaticon-information',
									page: '/advancedSetup/bookChapterPublication',
									entPermission: 'viewBookChapterPublicationList',
								},
								{
									title: 'Resource Person',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/advancedSetup/resourcePerson',
									entPermission: 'viewResourcePersonList',
								},
							{
							title: 'Incentive Report',
							bullet: 'dot',
							icon: 'flaticon-information',
							page: '/advancedSetup/incentiveReport',
							entPermission: 'isResearchPublicationAdmin',
						},
							]
						}
					]
				},
				{
					title: 'Analytics',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-analytics',
					page: '/analytics',
					entPermission: 'analyticsModule',
					submenu: [
						{
							title: 'Analytics',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/analytics/dashboard',
							entPermission: 'analyticsModule',
							submenu: [
								{
									title: 'Dashboard',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/analytics/dashboard',
									entPermission: 'viewAnalyticsDashboard',
								},
								{
									title: 'Registration',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/analytics/registration',
									entPermission: 'viewRegistrationAnalyticsList',
								},
								{
									title: 'Admission',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/analytics/admission',
									entPermission: 'viewAdmissionAnalyticsList',
								},
							]
						},
						{
							title: 'Partner Institutes',
							bullet: 'dot',
							// page:'/analytics/partnerInstitute',
							entPermission: 'viewPartnerInstituteList',
							submenu: [
								{
									title: 'Manage',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerInstitute',
									entPermission: 'viewPartnerInstituteList',
								},
								{
									title: 'Registration Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerRegistrationData',
									entPermission: 'viewPartnerRegistrationSummary',
								},
								{
									title: 'Admission Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerAdmissionData',
									entPermission: 'viewPartnerAdmissionSummary',
								},
							]
						},
						{
							title: 'Admission Reports',
							bullet: 'dot',
							// page:'/analytics/partnerInstitute',
							entPermission: 'viewAnalyticsReports',
							submenu: [
								{
									title: 'Registration Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/registrationReport',
									entPermission: 'viewRegistrationReports',
								},
								{
									title: 'Admission Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/admissionReport',
									entPermission: 'viewAdmissionSummaryReport',
								},
								{
									title: 'Partner Registration Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerRegistrationData',
									entPermission: 'viewPartnerRegistrationSummary',
								},
								{
									title: 'Partner Admission Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerAdmissionData',
									entPermission: 'viewPartnerAdmissionSummary',
								},
							]
						},
						{
							title: 'Partner Companies',
							bullet: 'dot',
							// page:'/analytics/partnerCompany',
							entPermission: 'analyticsModule',
							// page: '/analytics/partnerCompany'
							submenu: [
								{
									title: 'Partner Companies',
									bullet: 'dot',
									// page:'/analytics/partnerCompany',
									entPermission: 'viewPartnerCompanyList',
									page: '/analytics/partnerCompany'
								},
								{
									title: 'Visits',
									bullet: 'dot',
									page: '/analytics/visit',
									entPermission: 'viewVisitList'
								},
								{
									title: 'Placement Drive',
									bullet: 'dot',
									page: '/analytics/placementDrive',
									entPermission: 'viewPlacementDriveList',
								},
							]
						},
						{
							title: 'Placement Reports',
							bullet: 'dot',
							// page:'/analytics/partnerInstitute',
							entPermission: 'getCompanyListPlacementDriveData',
							submenu: [
								{
									title: 'Partner Placement Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerPlacementSummary',
									entPermission: 'getCompanyListPlacementDriveData',
								},
								{
									title: 'Placement Summary',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/placementSummary',
									entPermission: 'getPlacementDriveSummary',
								},
								{
									title: 'Partner Summary Session Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerSummarySessionWise',
									entPermission: 'getSessionWisePlacementDriveSummary',
								},
								{
									title: 'Partner Placement Summary Session Wise',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/analytics/partnerPlacementSummarySessionWise',
									entPermission: 'getSessionWiseCompanyListPlacementDriveData',
								},

							]
						},



					]
				},
				{
					title: 'Bulk Operations',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-group',
					//page: '/reportFile',
					// entPermission: 'viewReportFileList',
					submenu: [
						{
							title: 'Bulk Operations',
							bullet: 'dot',
							// icon: 'flaticon-coins',
							// page: '/reportFile',
							// entPermission: 'viewReportFileList',
							submenu:[
								{
									title: 'Report File',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/reportFile',
									// entPermission: 'viewReportFileList'
								},
								{
									title: 'Excel Upload Logs',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/reportFile/excelUploadLogs',
									entPermission: 'viewExcelUploadLogsList',
								},
								{
									title: 'Bulk Request Logs',
									bullet: 'dot',
									// icon: 'flaticon-coins',
									page: '/reportFile/bulkRequestFeeHead',
									entPermission: 'viewBulkRequestList',
								},
							]
						}

					]
				},
				{
					title: 'Share Point',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-share',
					page: '/sharePoint',
					entPermission: 'sharePointModule'
				},

				{
					title: 'Social Media',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-analytics',
					page: '/socialMedia',
					entPermission: 'socialMediaModule'
				},

				{
					title: 'Question Paper',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-analytics',
					//page: '/questionPaper',
					//page:'/transportAttendance',
					entPermission: 'viewQuestionPaperList',
					submenu: [
						{
							title: 'Add Question Bank List',
							bullet: 'dot',
							page: '/questionPaper/questionBank',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewQuestionBankList',
							// translate: 'MENU.DASHBOARD',
						},
						{
							title: 'Generate Question Paper ',
							bullet: 'dot',
							page: '/questionPaper/genrateQuestionPaper',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'addQuestionPaper',
							// translate: 'MENU.DASHBOARD',
						},
						{
							title: 'List Question Paper',
							bullet: 'dot',
							page: '/questionPaper/listQuestionPaper',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewQuestionPaperList',
							// translate: 'MENU.DASHBOARD',
						},

					]
				},
				{
					title: 'NAAC',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-report',
					page: '/naac',
					entPermission: 'naacModule',
					submenu: [
						{
							title: 'Criterion 1',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewNAACCriterion1',
							// translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Metric 1.1.3',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric1.1.3',
									entPermission: 'viewCriterion_1_1_3List',
								},
								{
									title: 'Metric 1.2.1',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric1.2.1',
									entPermission: 'viewCriterion_1_2_1List',
								},
								{
									title: 'Metric 1.2.2  & 1.2.3',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric1.2.2',
									entPermission: 'viewCriterion_1_2_2List',
								},
								{
									title: 'Metric 1.3.2',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric1.3.2',
									entPermission: 'viewCriterion_1_3_2List',
								},
								{
									title: 'Metric 1.3.3',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric1.3.3',
									entPermission: 'viewCriterion_1_3_3List',
								},


							]
						},
						{
							title: 'Criterion 2',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewNAACCriterion2',
							// translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Metric 2.1.1',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric2.1.1',
									entPermission: 'viewCriterion_2_1_1List',
								},
								{
									title: 'Metric 2.1.2',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric2.1.2',
									entPermission: 'viewCriterion_2_1_2List',
								},
								{
									title: 'Metric 2.2.2 & 2.3.3 & 2.4.1 & 2.4.3',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric2.2.2',
									entPermission: 'viewCriterion_2_2_2List',
								},
								{
									title: 'Metric 2.4.2',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric2.4.2',
									entPermission: 'viewCriterion_2_4_2List',
								},
								{
									title: 'Metric 2.6.3',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric2.6.3',
									entPermission: 'viewCriterion_2_6_3List',
								},
								{
									title: 'Metric 2.7.1',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric2.7.1',
									entPermission: 'viewCriterion_2_7_1List',
								},


							]
						},
						{
							title: 'Criterion 3',
							bullet: 'dot',
							// icon: 'flaticon2-list-2',
							// page: '/feeReports',
							entPermission: 'viewNAACCriterion3',
							// translate: 'MENU.DASHBOARD',
							submenu: [
								{
									title: 'Metric 3.1.1 & 3.1.3',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric3.1.1',
									entPermission: 'viewCriterion_3_1_1List',
								},
								{
									title: 'Metric 3.1.2 & 3.3.1',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric2.4.2',
									entPermission: 'viewCriterion_2_4_2List',
								},
								{
									title: 'Metric 3.2.2',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric3.2.2',
									entPermission: 'viewCriterion_3_2_2List',
								},
								{
									title: 'Metric 3.3.2',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric3.3.2',
									entPermission: 'viewCriterion_3_3_2List',
								},
								{
									title: 'Metric 3.3.3',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric3.3.3',
									entPermission: 'viewCriterion_3_3_3List',
								},
								{
									title: 'Metric 3.4.2',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric3.4.2',
									entPermission: 'viewCriterion_3_4_2List',
								},
								{
									title: 'Metric 3.4.3 & 3.4.4',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric3.4.3',
									entPermission: 'viewCriterion_3_4_3List',
								},
								{
									title: 'Metric 3.5.1',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric3.5.1',
									entPermission: 'viewCriterion_3_5_1List',
								},
								{
									title: 'Metric 3.5.2',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/naac/metric3.5.2',
									entPermission: 'viewCriterion_3_5_2List',
								},


							]
						},



					]
				},
				{
					title: 'Gallery',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-analytics',
					page: '/gallery',
					entPermission: 'viewGalleryList'
				},
				{
					title: 'Student Queries',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-analytics',
					page: '/studentQueries',
					entPermission: 'viewStudentQueryList'
				},
				// {
				// 	title: 'WebOPAC',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'flaticon3-analytics',
				// 	page: `/web-opac`,
				// 	entPermission: 'viewWebOPAC',
				// },
				{
					title: 'CMS',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-analytics',
					page: '/cms',
					entPermission: 'viewEntityWebsiteConfig'
				},
             	{
					title: 'LMS',
					root: true,
					bullet: 'dot',
					icon: 'flaticon3-analytics',
					// page: '/extraMarksLMS',
					entPermission: 'extraMarksLMS',
					submenu: [
								{
									title: 'LMS',
									bullet: 'dot',
									// icon: 'flaticon2-list-2',
									page: '/extraMarksLMS',
									entPermission: 'extraMarksLMS',
								},
					]
				},
				{
					title: 'Utilities',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list-2',
					page: '/utilities',
					entPermission: 'viewInstituteMaster'
				},
			]
		},
		studentHeader: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					alignment: 'left',
					page: '/studentDashboard',
					studentPermission: 'dashboardStudent'
				},
				{
					title: 'Fee Receipts',
					root: true,
					alignment: 'left',
					page: '/studentDashboard/feeReceipts',
					studentPermission: 'feeModuleStudent'
				},
				{
					title: 'Profile',
					root: true,
					alignment: 'left',
					page: '/studentDashboard/profile',
					studentPermission: 'profileStudent'
				},
			]
		},
		studentAside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					icon: 'flaticon3-house',
					page: '/studentDashboard',
					bullet: 'dot',
					studentPermission: 'dashboardStudent'
				},
				{
					title: 'Fee Receipts',
					root: true,
					icon: 'flaticon2-list-2',
					page: '/studentDashboard/feeReceipts',
					bullet: 'dot',
					studentPermission: 'feeModuleStudent'
				},
				{
					title: 'Profile',
					root: true,
					icon: 'flaticon-profile-1',
					page: '/studentDashboard/profile',
					bullet: 'dot',
					studentPermission: 'profileStudent'
				},
			]
		}
	};

	public get configs(): any {
		return this.defaults;
	}
}
